<template>
  <Loader v-if="loader" />
  <div class="flex" style="display: flex; justify-content: flex-start; margin: 20px">
    <InputText v-model="searchTerm" placeholder="Cerca..." class="p-inputtext p-component"
      style="width: 300px; margin-right: 10px;" />
    <Button
      :label="loader ? 'Caricamento...':'Cerca'"
      :icon="loader ? 'pi pi-spinner pi-spin':'pi pi-search'"
      class="p-button-primary"
      style="margin-right: 10px;"
      @click="onSearch"
      :disabled="loader"
    />
    <Button
      :label="allCurrentPageSelected ? 'Esporta tutto' : 'Esporta selezionati'"
      icon="pi pi-download"
      class="p-button-secondary"
      @click="exportToExcel"
      style="margin-right: 10px;"
      :disabled="selectedRows.length === 0"
    />

    <!-- <Button label="Visualizza tutti" :class="{ 'active-button': activeFilter === null }" class="small-button ml-2" @click="setActiveFilter(null)" style="margin-right: 10px;" /> -->
    <Button label="Visualizza POD" :class="{ 'active-button': activeFilter === 'pod' }" class="small-button"
      @click="setActiveFilter('pod')" style=" margin-right: 10px;" />
    <Button label="Visualizza PDR" :class="{ 'active-button': activeFilter === 'pdr' }" class="small-button ml-2"
      @click="setActiveFilter('pdr')" style="margin-right: 10px;" />
  </div>
  <hr style="margin: 20px 0; border-top: 0.5px solid #ccc;" />
  <div ref="tableContainerRef" class="table-container" style="overflow-x: auto" tabindex="0">
    <Dialog v-model:visible="dialogVisible" modal header="Aggiungi Nuova Pratica" :style="{ width: '70rem' }">
      <div class="p-fluid">
        <!-- Selezione Tipo Pratica -->
        <div class="p-field p-grid">
          <label for="tipoPratica" class="p-col-12 p-md-2"><b>Tipo Pratica:</b></label>
          <div class="p-col-12 p-md-4 mb-3" style="margin-top: 10px; display: flex; align-items: center;">
            <div style="margin-right: 30px; display: flex; align-items: center;">
              <RadioButton inputId="Gas" name="tipoPratica" value="Gas" v-model="nuovaPratica.tipoPratica" />
              <label for="Gas" class="p-radiobutton-label" style="margin-left: 10px;">Gas</label>
            </div>
            <div style="display: flex; align-items: center;">
              <RadioButton inputId="Elettrico" name="tipoPratica" value="Elettrico"
                v-model="nuovaPratica.tipoPratica" />
              <label for="Elettrico" class="p-radiobutton-label" style="margin-left: 10px;">Elettrico</label>
            </div>
          </div>
        </div>
    
        <!-- Campi per Elettrico -->
        <div v-if="nuovaPratica.tipoPratica === 'Elettrico'">
          <!-- Codice Pod/Pdr -->
          <div class="p-field p-grid">
            <label for="code" class="p-col-12 p-md-2"><b>Codice Pod:</b></label>
            <div class="p-col-12 p-md-4" style="margin-top: 10px">
              <InputText id="code" v-model="nuovaPratica.code" />
            </div>
          </div>

          <!-- Numero di Telefono -->
          <div class="p-field p-grid">
            <label for="telefono" class="p-col-12 p-md-2"><b>Numero di Telefono:</b></label>
            <div class="p-col-12 p-md-4" style="margin-top: 10px">
              <InputText id="telefono" v-model="nuovaPratica.telefono" placeholder="+39 3331234567" />
            </div>
          </div>

          <!-- Nome e Cognome Rappresentante -->
          <div class="p-field p-grid">
            <label for="nomeRapp" class="p-col-12 p-md-2"><b>Nome:</b></label>
            <div class="p-col-12 p-md-4" style="margin-top: 10px">
              <InputText id="nomeRapp" v-model="nuovaPratica.nomerappresentante" />
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="cognomeRapp" class="p-col-12 p-md-2"><b>Cognome:</b></label>
            <div class="p-col-12 p-md-4" style="margin-top: 10px">
              <InputText id="cognomeRapp" v-model="nuovaPratica.cognomerappresentante" />
            </div>
          </div>

          <!-- Intestatario -->
          <div class="p-field p-grid">
            <label for="intestatario" class="p-col-12 p-md-2"><b>Intestatario:</b></label>
            <div class="p-col-12 p-md-4" style="margin-top: 10px">
              <InputText id="intestatario" v-model="nuovaPratica.intestatario" />
            </div>
          </div>

          <div class="p-field p-grid">
            <label for="indirizzo" class="p-col-12 p-md-2"><b>indirizzo:</b></label>
            <div class="p-col-12 p-md-4" style="margin-top: 10px">
              <InputText id="indirizzo" v-model="nuovaPratica.indirizzo" />
            </div>
          </div>

          <!-- Partita IVA -->
          <div class="p-field p-grid">
            <label for="partitaIva" class="p-col-12 p-md-2"><b>Partita Iva:</b></label>
            <div class="p-col-12 p-md-4" style="margin-top: 10px">
              <InputText id="partitaIva" v-model="nuovaPratica.partitaIva" />
            </div>
          </div>

           <!-- Email -->
          <div class="p-field p-grid">
            <label for="email" class="p-col-12 p-md-2"><b>Email:</b></label>
            <div class="p-col-12 p-md-4" style="margin-top: 10px">
              <InputText id="email" v-model="nuovaPratica.email" />
            </div>
          </div>

          <!-- Codice Fiscale -->
          <div class="p-field p-grid">
            <label for="codiceFiscale" class="p-col-12 p-md-2"><b>Codice Fiscale:</b></label>
            <div class="p-col-12 p-md-4" style="margin-top: 10px">
              <InputText id="codiceFiscale" v-model="nuovaPratica.codiceFiscale" />
            </div>
          </div>

          <!-- Ragione Sociale -->
          <div class="p-field p-grid">
            <label for="ragionesociale" class="p-col-12 p-md-2"><b>Ragione Sociale:</b></label>
            <div class="p-col-12 p-md-4" style="margin-top: 10px">
              <InputText id="ragionesociale" v-model="nuovaPratica.ragionesociale" />
            </div>
          </div>

          <!-- Agente -->
          <div class="p-field p-grid">
            <label for="agente" class="p-col-12 p-md-2"><b>Agente:</b></label>
            <div class="p-col-12 p-md-4" style="margin-top: 10px">
              <AutoComplete 
                v-model="nuovaPratica.agente" 
                :suggestions="filteredAgents" 
                @complete="searchAgents($event)"
                @item-select="onAgentSelect($event)"
                optionLabel="name" 
                placeholder="Cerca e seleziona Agente"
                :delay="300"
                :minLength="0"
                :dropdown="true"
                :forceSelection="false"
                :autoHighlight="true"
              />
              <small v-if="filteredAgents.length > 0" style="color: #666;">
                Trovati {{ filteredAgents.length }} agenti
              </small>
            </div>
          </div>

          <!-- Potenza Disponibile -->
          <div class="p-field p-grid">
            <label for="potenzaDisponibile" class="p-col-12 p-md-2"><b>Potenza Disponibile:</b></label>
            <div class="p-col-12 p-md-4" style="margin-top: 10px">
              <InputText id="potenzaDisponibile" v-model="nuovaPratica.potenzaDisponibile" />
            </div>
          </div>

          <!-- Potenza Impegnata -->
          <div class="p-field p-grid">
            <label for="potenzaImpegnata" class="p-col-12 p-md-2"><b>Potenza Impegnata:</b></label>
            <div class="p-col-12 p-md-4" style="margin-top: 10px">
              <InputText id="potenzaImpegnata" v-model="nuovaPratica.potenzaImpegnata" />
            </div>
          </div>

          <!-- Stagionalità -->
          <div class="p-field p-grid" style="margin-bottom: 10px">
            <label for="stagionalità" class="p-col-12 p-md-2" style="margin-top: 10px"><b>Stagionalità:</b></label>
            <div class="p-col-12 p-md-4" style="margin-top: 10px">
              <RadioButton inputId="Si" name="stagionalità" value="Si" v-model="nuovaPratica.stagionalità" />
              <label for="Si" class="p-radiobutton-label" style="margin-right: 10px">Si</label>
              <RadioButton inputId="No" name="stagionalità" value="No" v-model="nuovaPratica.stagionalità" />
              <label for="No" class="p-radiobutton-label">No</label>
            </div>
          </div>

          <!-- Tipo Connessione -->
          <div class="p-field p-grid" style="margin-bottom: 10px">
            <label for="Tipo Connessione" class="p-col-12 p-md-2" style="margin-top: 10px"><b>Tipo
                Connessione:</b></label>

            <div class="p-col-12 p-md-4" style="margin-top: 10px; display: flex; align-items: center;">
              <div style="margin-right: 20px; display: flex; align-items: center;">
                <RadioButton inputId="Temporanea" name="Tipo Connessione" value="Temporanea"
                  v-model="nuovaPratica.tipoConnessione" />
                <label for="Temporanea" class="p-radiobutton-label" style="margin-left: 5px;">Temporanea</label>
              </div>

              <div style="display: flex; align-items: center;">
                <RadioButton inputId="Permanente" name="Tipo Connessione" value="Permanente"
                  v-model="nuovaPratica.tipoConnessione" />
                <label for="Permanente" class="p-radiobutton-label" style="margin-left: 5px;">Permanente</label>
              </div>
            </div>
          </div>

          <div v-if="nuovaPratica.tipoConnessione === 'Temporanea'">
            <label>Data Fine Temporanea: </label>
            <input 
              type="date" 
              v-model="nuovaPratica.dataFineTemporanea"
              required
            >
          </div>

          <!-- Tensione -->
          <div class="p-field p-grid">
            <label for="tensione" class="p-col-12 p-md-2"><b>Tensione:</b></label>
            <div class="p-col-12 p-md-4" style="margin-top: 10px">
              <Dropdown v-model="nuovaPratica.tensione" :options="tensioneOptions" />
            </div>
          </div>

          <!-- Tensione -->
          <div class="p-field p-grid">
            <label for="tipologiauso" class="p-col-12 p-md-2 mt-2"><b>Tipologia Uso:</b></label>
            <div class="p-col-12 p-md-4" style="margin-top: 10px">
              <Dropdown v-model="nuovaPratica.tipologiauso" :options="tipologiaUsoOptions" />
            </div>
          </div>

          <!-- Disalimentabile -->
          <div class="p-field p-grid">
            <label for="disalimentabile" class="p-col-12 p-md-2"><b>Disalimentabile:</b></label>
            <div class="p-col-12 p-md-4" style="margin-top: 10px">
              <Dropdown v-model="nuovaPratica.disalimentabile" :options="disalimentabileOptions" />
            </div>
          </div>

          <!-- Tipologia Contrattuale -->
          <div class="p-field p-grid">
            <label for="tipologiaContrattuale" class="p-col-12 p-md-2"><b>Tipologia Contrattuale:</b></label>
            <div class="p-col-12 p-md-4" style="margin-top: 10px">
              <Dropdown v-model="nuovaPratica.tipologiaContrattuale" :options="tipologiaContrattualeOptions" />
            </div>
          </div>
        </div>

        <!-- Campi per Gas -->
        <div v-if="nuovaPratica.tipoPratica === 'Gas'">
          <!-- Codice Pod/Pdr -->
          <div class="p-field p-grid">
            <label for="code" class="p-col-12 p-md-2"><b>Codice Pdr:</b></label>
            <div class="p-col-12 p-md-4" style="margin-top: 10px">
              <InputText id="code" v-model="nuovaPratica.code" />
            </div>
          </div>

          <!-- Matricola -->
          <div class="p-field p-grid">
            <label for="code" class="p-col-12 p-md-2"><b>Matricola:</b></label>
            <div class="p-col-12 p-md-4" style="margin-top: 10px">
              <InputText id="code" v-model="nuovaPratica.matricola" />
            </div>
          </div>

          <!-- Numero di Telefono -->
          <div class="p-field p-grid">
            <label for="telefono" class="p-col-12 p-md-2"><b>Numero di Telefono:</b></label>
            <div class="p-col-12 p-md-4" style="margin-top: 10px">
              <InputText id="telefono" v-model="nuovaPratica.telefono" placeholder="+39 3331234567" />
            </div>
          </div>

          <!-- Nome e Cognome Rappresentante -->
          <div class="p-field p-grid">
            <label for="nomeRapp" class="p-col-12 p-md-2"><b>Nome:</b></label>
            <div class="p-col-12 p-md-4" style="margin-top: 10px">
              <InputText id="nomeRapp" v-model="nuovaPratica.nomerappresentante" />
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="cognomeRapp" class="p-col-12 p-md-2"><b>Cognome:</b></label>
            <div class="p-col-12 p-md-4" style="margin-top: 10px">
              <InputText id="cognomeRapp" v-model="nuovaPratica.cognomerappresentante" />
            </div>
          </div>

          <!-- Intestatario -->
          <div class="p-field p-grid">
            <label for="intestatario" class="p-col-12 p-md-2"><b>Intestatario:</b></label>
            <div class="p-col-12 p-md-4" style="margin-top: 10px">
              <InputText id="intestatario" v-model="nuovaPratica.intestatario" />
            </div>
          </div>

          <div class="p-field p-grid">
            <label for="indirizzo" class="p-col-12 p-md-2"><b>indirizzo:</b></label>
            <div class="p-col-12 p-md-4" style="margin-top: 10px">
              <InputText id="indirizzo" v-model="nuovaPratica.indirizzo" />
            </div>
          </div>

          <!-- Partita IVA -->
          <div class="p-field p-grid">
            <label for="partitaIva" class="p-col-12 p-md-2"><b>Partita Iva:</b></label>
            <div class="p-col-12 p-md-4" style="margin-top: 10px">
              <InputText id="partitaIva" v-model="nuovaPratica.partitaIva" />
            </div>
          </div>

          <!-- Email -->
          <div class="p-field p-grid">
            <label for="email" class="p-col-12 p-md-2"><b>Email:</b></label>
            <div class="p-col-12 p-md-4" style="margin-top: 10px">
              <InputText id="email" v-model="nuovaPratica.email" />
            </div>
          </div>

          <!-- Codice Fiscale -->
          <div class="p-field p-grid">
            <label for="codiceFiscale" class="p-col-12 p-md-2"><b>Codice Fiscale:</b></label>
            <div class="p-col-12 p-md-4" style="margin-top: 10px">
              <InputText id="codiceFiscale" v-model="nuovaPratica.codiceFiscale" />
            </div>
          </div>

          <!-- Ragione Sociale -->
          <div class="p-field p-grid">
            <label for="ragionesociale" class="p-col-12 p-md-2"><b>Ragione Sociale:</b></label>
            <div class="p-col-12 p-md-4" style="margin-top: 10px">
              <InputText id="ragionesociale" v-model="nuovaPratica.ragionesociale" />
            </div>
          </div>

          <!-- Agente -->
          <div class="p-field p-grid">
            <label for="agente" class="p-col-12 p-md-2"><b>Agente:</b></label>
            <div class="p-col-12 p-md-4" style="margin-top: 10px">
              <AutoComplete 
                v-model="nuovaPratica.agente" 
                :suggestions="filteredAgents" 
                @complete="searchAgents($event)"
                @item-select="onAgentSelect($event)"
                optionLabel="name" 
                placeholder="Cerca e seleziona Agente"
                :delay="300"
                :minLength="0"
                :dropdown="true"
                :forceSelection="false"
                :autoHighlight="true"
              />
              <small v-if="filteredAgents.length > 0" style="color: #666;">
                Trovati {{ filteredAgents.length }} agenti
              </small>
            </div>
          </div>

          <!-- Remi -->
          <div class="p-field p-grid">
            <label for="remi" class="p-col-12 p-md-2"><b>Remi:</b></label>
            <div class="p-col-12 p-md-4" style="margin-top: 10px">
              <InputText id="remi" v-model="nuovaPratica.remi" />
            </div>
          </div>

          <!-- Connessione Gas -->
          <div class="p-field p-grid">
            <label for="connessione" class="p-col-12 p-md-2"><b>Connessione:</b></label>
            <div class="p-col-12 p-md-4" style="margin-top: 10px">
              <Dropdown v-model="nuovaPratica.connessioneGas" :options="connessioneGasOptions" />
            </div>
          </div>

          <!-- Portata Kwh -->
          <div class="p-field p-grid">
            <label for="portataKwh" class="p-col-12 p-md-2"><b>Portata Kwh:</b></label>
            <div class="p-col-12 p-md-4" style="margin-top: 10px">
              <InputText id="portataKwh" v-model="nuovaPratica.portataKwh" />
            </div>
          </div>

          <!-- Classe Misuratore -->
          <div class="p-field p-grid">
            <label for="classeMisuratore" class="p-col-12 p-md-2"><b>Classe Misuratore:</b></label>
            <div class="p-col-12 p-md-4" style="margin-top: 10px">
              <Dropdown v-model="nuovaPratica.classeMisuratore" :options="classeMisuratoreOptions" />
            </div>
          </div>

        <!-- Categoria Uso (solo Gas) -->
        <div class="p-field p-grid">
          <label for="categoriaUsoGas" class="p-col-12 p-md-2"><b>Categoria Uso:</b></label>
          <div class="p-col-12 p-md-4" style="margin-top: 10px">
            <InputText
              id="categoriaUsoGas"
              v-model="nuovaPratica.new_categoria_uso"
              placeholder="Es. C1, C2, C3, C4, C5, T1, T2"
            />
            <small style="display: block; margin-top: 4px; color: #666;">
              Categorie ammesse: C1, C2, C3, C4, C5, T1, T2
            </small>
          </div>
        </div>

          <!-- Tipologia Contrattuale -->
          <div class="p-field p-grid">
            <label for="tipologiaContrattuale" class="p-col-12 p-md-2"><b>Tipologia Contrattuale:</b></label>
            <div class="p-col-12 p-md-4" style="margin-top: 10px">
              <Dropdown v-model="nuovaPratica.tipologiaContrattuale" :options="tipologiaContrattualeOptions" />
            </div>
          </div>

          <!-- Tipo Connessione -->
          <div class="p-field p-grid" style="margin-bottom: 10px">
            <label for="Tipo Connessione" class="p-col-12 p-md-2" style="margin-top: 10px"><b>Tipo
                Connessione:</b></label>
            <div class="p-col-12 p-md-4" style="margin-top: 10px; display: flex; align-items: center;">

              <RadioButton inputId="Temporanea" name="Tipo Connessione" value="Temporanea"
                v-model="nuovaPratica.tipoConnessione" />
              <label for="Temporanea" class="p-radiobutton-label" style="margin-right: 10px">Temporanea</label>
              <RadioButton inputId="Permanente" name="Tipo Connessione" value="Permanente"
                v-model="nuovaPratica.tipoConnessione" />
              <label for="Permanente" class="p-radiobutton-label">Permanente</label>
            </div>
          </div>
        </div>

        <div class="dialog-footer" style="text-align: center">
          <Button label="Aggiungi" icon="pi pi-plus-circle" class="p-button-success" @click="aggiungiPraticaConferma"
            style="margin-top: 5%; width: auto; min-width: 150px;" />
        </div>
      </div>
    </Dialog>

    <div v-if="showSuccessAlert" class="p-col-12 p-d-flex p-jc-center" style="
        margin-top: 20px;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 9999;
      ">
      <div class="p-alert p-component p-alert-success" role="alert" style="
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
          border-radius: 4px;
          background-color: #52c41a;
          color: #fff;
          padding: 10px 20px;
        ">
        <div class="p-alert-content">Pratica aggiunta con successo!</div>
      </div>
    </div>
    <div v-if="showSuccessAlert2" class="p-col-12 p-d-flex p-jc-center" style="
        margin-top: 20px;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 9999;
      ">
      <div class="p-alert p-component p-alert-success-allegato" role="alert" style="
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
          border-radius: 4px;
          background-color: #52c41a;
          color: #fff;
          padding: 10px 20px;
        ">
        <div class="p-alert-content">Allegato caricato con successo!</div>
      </div>
    </div>
    <div v-if="filteredModificaPosaContatore.length === 0">
      <p class="text-center">Non ci sono pratiche al momento.</p>
    </div>
    <DataTable 
      :value="filteredModificaPosaContatore" 
      dataKey="id" 
      selectionMode="multiple"
      v-model:selection="selectedRows" 
      tableStyle="min-width: 75rem"
      :sortField="'id'"  
      :sortOrder="-1"
      :paginator="true"
      :rows="pagination.per_page"
      :totalRecords="pagination.total"
      :lazy="true"
      :first="(pagination.current_page - 1) * pagination.per_page"
      @page="onPage"
    >
      <Column selectionMode="multiple" headerStyle="width: 3em"></Column>
      <Column header="Stato Pratica">
        <template #body="{ data }">
          <Button icon="pi pi-info-circle" @click="() => openInfoDialog(data, index)"></Button>
        </template>
      </Column>
      <div style="display: flex; align-items: center;  justify-content: flex-end; margin: 20px;">
        <div v-if="user && allowedIdUser.includes(user.id)" style="margin-right: 10px;">
          <Dropdown v-model="massiveSelectedStatus" :options="statiMassivi" optionLabel="stato"
            placeholder="Seleziona Stato" />
        </div>
        <Button label="Applica Stato" class="ml-1" @click="applyMassiveStatusChange"
          :disabled="!(user && allowedIdUser.includes(user.id))" style="margin-right: 10px;" />
        <Button :icon="isActive ? 'pi pi-eye' : 'pi pi-eye-slash'"
          :class="['small-button', { 'active-button': isActive }]" @click="rimuoviFiltroStato"
          style="margin-right: 10px;" />
        <Button label="Aggiungi Pratica" icon="pi pi-plus" class="p-button-success" @click="aggiungiPratica" />
      </div>
      <Column field="tipo" header="Tipo Pratica" style="width: 150px"></Column>
      <Column field="id" header="Id Pratica" style="width: 150px"> </Column>
      <Column header="Data Inserimento" style="width: 150px">
        <template #body="{ data }">
          {{ data?.data ?? "" }}
        </template>
      </Column>
      <!-- <Column field="name" header="Nome Rappresentante" style="width: 150px">
        <template #body="{ data }">
          <p
            @click="handleButtonClick2(data.rappid)"
            class="text-primary cursor-pointer"
          >
            {{ data.name }}
          </p>
        </template>
      </Column> -->

      <Column field="nomerappresentante" header="Nome" style="width: 150px">
      </Column>
      <Column field="cognomerappresentante" header="Cognome" style="width: 150px"></Column>
      <Column field="indirizzo" header="Indirizzo" style="width: 150px"></Column>
      <Column field="ragionesociale" header="Ragione Sociale" style="width: 150px">
      </Column>
      <Column field="sede_legale" header="Sede Legale" style="width: 150px"></Column>
      <Column field="intestatario" header="Nome e Cognome"></Column>
      <Column field="codice_fiscale" header="Codice Fiscale"></Column>
      <Column field="partita_iva" header="Partita Iva"></Column>
      <Column field="email" header="Email"></Column>
      <Column field="codicepod" header="Code">
        <template #body="{ data }">
          <div class="editable-cell">
            <p
              v-if="data && !data.isEditingCode && canEditCode(data)"
              class="text-primary cursor-pointer"
              @click="startCodeEditing(data)"
            >
              {{ data.codicepod || "Inserisci Code" }}
            </p>
            <span v-else-if="data && !data.isEditingCode">
              {{ data.codicepod || "" }}
            </span>
            <input
              v-if="data && data.isEditingCode"
              :value="data.codicepod || ''"
              @input="data && (data.codicepod = $event.target.value)"
              @keydown.enter="stopCodeEditing(data)"
              @blur="stopCodeEditing(data)"
            />
          </div>
        </template>
      </Column>
      <Column field="matricola" header="Matricola"></Column>
      <Column
        v-if="activeFilter === 'pdr'"
        header="Categoria Uso"
        style="width: 140px"
      >
        <template #body="{ data }">
          {{ data.new_categoria_uso || data.categoria_uso || '' }}
        </template>
      </Column>
      <Column field="udd" header="UDD" editMode="cell">
        <template #body="{ data }">
          <div class="editable-cell">
            <p class="text-primary cursor-pointer" @click="startEditing(data)" v-if="data && !data.isEditing">
              {{ data && data.udd ? data.udd : "Inserisci UDD" }}
            </p>
            <input v-if="data && data.isEditing" :value="data && data.udd ? data.udd : ''"
              @input="data && (data.udd = $event.target.value)" @keydown.enter="stopEditing(data)"
              @blur="stopEditing(data)" />
          </div>
        </template>
      </Column>

      <Column field="codicePratica" header="Codice Pratica" editMode="cell">
        <template #body="{ data }">
          <div class="editable-cell">
            <p class="text-primary cursor-pointer" @click="startEditing(data)" v-if="data && !data.isEditing">
              {{
                data && data.codicePratica
                  ? data.codicePratica
                  : "Inserisci Codice Pratica"
              }}
            </p>
            <input v-if="data && data.isEditing" :value="data && data.codicePratica ? data.codicePratica : ''"
              @input="data && (data.codicePratica = $event.target.value)" @keydown.enter="stopEditing(data)"
              @blur="stopEditing(data)" />
          </div>
        </template>
      </Column>
      <Column field="numero_telefono" header="Telefono"></Column>
      <Column field="new_attivazione" header="Tipo Attivazione" style="width: 150px"></Column>
      <Column field="new_potenza_impegnata" header="Potenza Impegnata Richiesta" style="width: 150px"></Column>
      <Column field="new_potenza_disponibile" header="Potenza Disponibile Richiesta" style="width: 150px"></Column>
      <Column field="new_tensione" header="Tensione Richiesta" style="width: 150px"></Column>
      <Column field="new_tipologia_uso" header="Tipologia Uso" style="width: 150px"></Column>
      <Column field="new_disalimentabile" header="Disalimentabile" style="width: 150px"></Column>
      <Column field="new_type_contratto" header="Tipo Contratto Richiesto" style="width: 150px"></Column>
      <Column field="new_type_connessione" header="Tipo Connessione" style="width: 150px"></Column>
      <Column field="new_stagionalità" header="Stagionalità" style="width: 150px"></Column>
      <Column field="distributore" header="Distributore" editMode="cell">
        <template #body="{ data }">
          <div class="editable-cell">
            <p class="text-primary cursor-pointer" @click="startEditing(data)" v-if="data && !data.isEditing">
              {{
                data && data.distributore
                  ? data.distributore
                  : "Inserisci Distributore"
              }}
            </p>
            <input v-if="data && data.isEditing" :value="data && data.distributore ? data.distributore : ''"
              @input="data && (data.distributore = $event.target.value)" @keydown.enter="stopEditing(data)"
              @blur="stopEditing(data)" />
          </div>
        </template>
      </Column>
      <Column field="remi" header="Remi" style="width: 150px"></Column>
      <Column field="connessione" header="Connessione" style="width: 150px"></Column>
      <Column field="portata_kwh" header="Portata Kwh" style="width: 150px"></Column>
      <Column field="classe_misuratore" header="Classe Misuratore" style="width: 150px"></Column>
      <Column field="data_fine" header="Data Fine" style="width: 150px"></Column>
      <Column field="data_temporanea" header="Data temporanea" style="width: 150px"></Column>
      <Column header="" style="min-width: 200px">
        <template #header>
          <div style="
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              gap: 8px;
            ">
            <span>Ultimo Stato</span>
            <Dropdown :options="statiDisponibili" optionLabel="stato" placeholder="Seleziona stato"
              v-model="selectedState" showClear @change="filterByUltimoStato" class="small-dropdown"
              style="width: 120px; font-size: 14px" />
          </div>
        </template>
        <template #body="{ data }">
          <span>
            {{ data && data.ultimo_stato ? data.ultimo_stato : 'non lavorato' }}
          </span>
        </template>
      </Column>
      <Column field="agente" header="Agente" style="width: 150px"></Column>
      <Column field="ultimaNota" header="Ultima Nota">
        <template #body="{ data }">
          <span>{{ data && data.ultima_nota ? data.ultima_nota : "" }}</span>
        </template>
      </Column>
      <Column header="Data Ultimo Stato">
        <template #body="{ data }">
          <span>{{ data && data.data_ultima_nota ? data.data_ultima_nota : "" }}</span>
        </template>
      </Column>
      <Column field="user" header="Utente"></Column>
      <Column v-if="activeFilter === 'pdr'" header="Richiesta appuntamento" style="width: 250px">
        <template #body="{ data }">
          <span
            v-if="data.appuntamento"
            :title="data.appuntamento"
            style="max-width: 200px; display: inline-block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
          >
            {{ data.appuntamento }}
          </span>
          <span v-else class="text-500">Nessuna richiesta</span>
        </template>
      </Column>
      <Column header="Azioni" style="width: 120px">
        <template #body="{ data }">
          <div class="flex align-items-center">
            <AppuntamentoPratica v-if="activeFilter === 'pdr'" :pratica="data" tipo-pratica="posa_contatore" :supply-code="data.codicepod" />
            <Button 
              icon="pi pi-trash" 
              class="p-button-danger p-button-text" 
              @click="() => openDeleteDialog(data)"
              v-tooltip.left="'Elimina pratica'"
            />
          </div>
        </template>
      </Column>
    </DataTable>
    <!-- <div
      v-if="pagination && pagination.total > 0"
      class="pagination-summary"
    >
      <span>
        Pagina {{ pagination.current_page }} di {{ pagination.last_page }}
      </span>
      <span class="pagination-summary__records">
        Record mostrati:
        {{
          (pagination.current_page - 1) * pagination.per_page + 1
        }}
        -
        {{
          Math.min(pagination.current_page * pagination.per_page, pagination.total)
        }}
        di {{ pagination.total }}
      </span>
    </div> -->
  </div>
  <Dialog v-model:visible="dialoginfo" modal header="Stato Pratiche" :style="{ width: '80rem' }"
    :breakpoints="{ '1199px': '75vw', '575px': '90vw' }" class="custom-dialog stato-dialog">
    <div class="dialog-content stato-layout">
      <div class="timeline-container">
        <Timeline v-if="timelineData && timelineData.length > 0" :value="timelineData" :key="timelineKey">
            <template #marker="slotProps">
              <span
                class="stato-punto"
                :class="{ 'stato-punto--attivo': selectedpratica.states && selectedpratica.states.length > 0 && Number(slotProps.item.numero) === Number(selectedpratica.states[0].cod_type_stato_pratica) }"
              ></span>
            </template>
            <template #content="slotProps">
              <div class="stato-passo">
                <span
                  class="stato-passo__nome"
                  :class="{ 'stato-passo__nome--attivo': selectedpratica.states && selectedpratica.states.length > 0 && Number(slotProps.item.numero) === Number(selectedpratica.states[0].cod_type_stato_pratica) }"
                >{{ slotProps.item.stato }}</span>
                <SottostatiTimeline
                :voci="slotProps.item.sottostati"
                :corrente="selectedpratica.states && selectedpratica.states[0] && selectedpratica.states[0].cod_type_stato_pratica"
              />
              </div>
            </template>
        </Timeline>
      </div>

              <div class="data-tables-container stato-pannello">
          <div class="stato-scheda" v-if="selectedpratica">
            <div class="stato-scheda__voce">
              <span>Pratica</span>
              <strong>Modifica posa contatore</strong>
            </div>
            <div class="stato-scheda__voce">
              <span>Cliente</span>
              <strong>{{
                selectedpratica.denominazione
                || [selectedpratica.nomerappresentante, selectedpratica.cognomerappresentante].filter(Boolean).join(" ")
                || [selectedpratica.NomeCliente, selectedpratica.CognomeCliente].filter(Boolean).join(" ")
                || selectedpratica.intestatario
                || "-"
              }}</strong>
            </div>
            <div class="stato-scheda__voce">
              <span>POD/PDR</span>
              <strong>{{ selectedpratica.code || "-" }}</strong>
            </div>
            <div class="stato-scheda__voce">
              <span>Stato attuale</span>
              <strong>{{ selectedpratica.stato_corrispondente || selectedpratica.stato_pratica || "-" }}</strong>
            </div>
          </div>
          <section class="stato-blocco stato-modulo" v-if="selectedpratica">
            <h3>Aggiorna stato</h3>
            <label class="stato-campo">
              <span>Stato</span>
              <Dropdown
                v-model="selectedpratica.selectedStato"
                :options="vedeSoloPreventivo(user) ? statiSoloPreventivo : newStati"
                optionLabel="stato"
                @change="changePraticaStatus(selectedpratica)"
              />
            </label>
            <label class="stato-privato">
              <input
                type="checkbox"
                v-model="selectedpratica.privato"
                @change="changePraticaStatus(selectedpratica)"
                :true-value="1"
                :false-value="0"
                :disabled="isPrivateAutomaticallyManaged"
              />
              Privato
            </label>
            <NotaInvioDocumentazione v-model="selectedpratica.nota" :pratica="selectedpratica">
              <template #default="{ openEditor, isDocumentationState }">
                <Button
                  v-if="isDocumentationState"
                  type="button"
                  label="Inserisci documentazione"
                  icon="pi pi-file-edit"
                  @click="openEditor"
                />
                <label v-else class="stato-campo">
                  <span>Nota</span>
                  <textarea
                    class="stato-nota"
                    :value="selectedpratica.nota || ''"
                    placeholder="Inserisci la nota"
                    @input="selectedpratica.nota = $event.target.value"
                  />
                </label>
              </template>
            </NotaInvioDocumentazione>
            <button
              type="button"
              class="styled-button-Nota"
              :class="{
                'styled-button-Nota--invio': faseInvioStato === 'invio',
                'styled-button-Nota--ok': faseInvioStato === 'inviato',
              }"
              :disabled="faseInvioStato === 'invio'"
              @click="inviaStatoAnimato(selectedpratica, 'ModificaPosaContatore')"
            >
              <span v-if="faseInvioStato === 'invio'" class="invio-stato__spinner" aria-hidden="true"></span>
              <span v-else-if="faseInvioStato === 'inviato'" class="invio-stato__check" aria-hidden="true">✓</span>
              {{ faseInvioStato === 'invio' ? 'Invio…' : faseInvioStato === 'inviato' ? 'Inviato' : 'Invia' }}
            </button>
          </section>
          <form @submit.prevent="onSubmitFileUpload" class="form-container stato-blocco stato-file">
            <h3>File</h3>
            <div class="stato-file__riga">
              <span class="stato-file__nome">Allegato</span>
              <div class="button-group">
            <label for="fileInput1" class="custom-file-upload" id="fileLabel1">
              Carica Allegato
            </label>
            <input type="file" id="fileInput1" @change="handleUploadPratiche($event)" class="file-input2" />
            <button v-if="selectedpratica !== null" @click="downloadAllegatoPratica(selectedpratica.id)"
              class="custom-file-download">
              Scarica Allegato
            </button>
          </div>
            </div>
            <div class="stato-file__riga">
              <span class="stato-file__nome">Preventivo</span>
              <div class="button-group">
            <label 
              v-if="user && allowedIdUser.includes(user.id)"
              for="fileInput2" 
              class="custom-file-upload" 
              id="fileLabel2"
            >
              <i class="fas fa-cloud-upload-alt"></i> Carica Preventivo
            </label>
            <input 
              v-if="user && allowedIdUser.includes(user.id)"
              type="file" 
              id="fileInput2" 
              @change="handleFileChange($event)" 
              class="file-input" 
            />
            <button 
              v-if="selectedpratica !== null" 
              @click="downloadPreventivoPratica(selectedpratica.id)" 
              class="custom-file-download"
            >
              <i class="pi pi-download"></i> Scarica Preventivo
            </button>
          </div>
            </div>
            <PreventivoFirmatoBox
            :stato="selectedpratica && selectedpratica.selectedStato"
            :pratica-id="selectedpratica && selectedpratica.id"
            type-file="ModificaPosaContatore"
            @file="impostaFilePreventivoFirmato"
          />
            <div class="p-alert-content" id="error-alert" style="display: none">
            Non ci sono file da scaricare.
          </div>
          </form>
          <section class="stato-blocco stato-storico">
            <h3>Storico note</h3>
            <DataTable :value="sortedStates" :paginator="true" :rows="3">
          <Column field="data_nota" header="Data"></Column>
          <Column field="stato_corrispondente" header="Stato"></Column>
          <Column field="nota" header="Nota"></Column>
          <Column field="is_private" header="Privato">
              <template #body="{ data }">
                <span 
                  v-if="data.is_private === 0" 
                  :class="canChangePrivate ? 'private-toggle cursor-pointer' : 'text-color-secondary'"
                  @click="canChangePrivate && togglePrivate(data)"
                >
                  No
                </span>
                <span 
                  v-else-if="data.is_private === 1"
                  :class="canChangePrivate ? 'private-toggle private-si cursor-pointer' : ''"
                  @click="canChangePrivate && togglePrivate(data)"
                >
                  SI
                </span>
              </template>
            </Column>
        </DataTable>
          </section>
          <section class="stato-blocco stato-importo">
            <h3>Importo</h3>
            <div v-if="preventivoEsistente" class="preventivo-esistente">
          <p><strong>Preventivo già inserito:</strong> € {{ preventivoEsistente.importo.toFixed(2) }}</p>
        </div>
        <button 
          v-else
          @click="openPreventivo" 
          class="styled-button-Nota-Preventivo"
        >
          Genera Preventivo
        </button>
          </section>
        </div>
    </div>
  </Dialog>
  <Dialog v-model:visible="preventivoDialog" modal header="Genera Preventivo" :style="{ width: '50rem' }">
      <div class="p-fluid">
        <div class="p-field p-grid mb-3">
          <label class="p-col-12"><b>Importo (€):</b></label>
          <div class="p-col-12 mt-2">
            <InputNumber v-model="importoPreventivo" mode="currency" currency="EUR" locale="it-IT" />
          </div>
        </div>

        <div class="p-field p-grid mb-2">
          <label class="p-col-12"><b>Dati Cliente:</b></label>
          <div class="p-col-12 mt-2">
            <div class="cliente-info">
              <p><b>Nome:</b> {{ selectedpratica?.nomerappresentante}}</p>
              <p><b>Cognome:</b> {{ selectedpratica?.cognomerappresentante}}</p>
              <p><b>Ragione Sociale:</b> {{ selectedpratica?.ragsoc || '-' }}</p>
              <p><b>Numero Telefono:</b> {{ selectedpratica?.numero_telefono || '-' }}</p>
              <p><b>Codice Fiscale:</b> {{ selectedpratica?.codiceFiscale || '-' }}</p>
              <p><b>Codice POD/PDR:</b> {{ selectedpratica?.code || '-' }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="dialog-footer" style="text-align: right; margin-top: 20px;">
        <Button label="Annulla" icon="pi pi-times" class="p-button-text" @click="preventivoDialog = false" />
        <Button label="Genera" icon="pi pi-check" class="p-button-success" @click="generaPreventivo" />
      </div>
    </Dialog>

  <Dialog 
    v-model:visible="dialogCompletamento" 
    modal 
    header="Data Completamento" 
    :style="{ width: '30rem' }"
  >
    <div class="p-fluid">
      <div class="p-field">
        <label for="codeCompletamento"><b>Code:</b></label>
        <div style="margin-top: 10px;">
          <InputMask
            id="codeCompletamento"
            v-model="codeCompletamento"
            :mask="codeCompletamentoMask"
            :required="true"
            placeholder="Inserisci il code"
            :disabled="salvataggioCompletamentoInCorso"
          />
        </div>
      </div>
      <small class="p-text-secondary">
        {{ matriceRicercaMessage }}
      </small>
      <small v-if="salvataggioCompletamentoInCorso" class="p-text-secondary completamento-saving-message">
        <i class="pi pi-spin pi-spinner"></i>
        Salvataggio completamento e avvio caricamento in corso...
      </small>
      <div v-if="matriceSuggerita" class="p-field matrice-suggestion">
        <label><b>Caricamento trovato:</b></label>
        <div style="margin-top: 10px;">
          La matrice ID {{ matriceSuggerita.matrice_id }} verra associata alla nuova posa.
        </div>
      </div>
      <div class="p-field">
        <label for="dataCompletamento"><b>Data Completamento:</b></label>
        <div style="margin-top: 10px;">
          <Calendar 
            v-model="dataCompletamento" 
            :showIcon="true" 
            dateFormat="dd/mm/yy" 
            class="w-full"
            id="dataCompletamento"
            :disabled="salvataggioCompletamentoInCorso"
          />
        </div>
      </div>
    </div>
    <div class="dialog-footer" style="text-align: right; margin-top: 20px;">
      <Button label="Annulla" icon="pi pi-times" class="p-button-text" @click="dialogCompletamento = false" :disabled="salvataggioCompletamentoInCorso" />
      <Button label="Conferma" icon="pi pi-check" class="p-button-success" @click="confermaCompletamento"
        :disabled="isConfermaCompletamentoDisabled"
        :loading="salvataggioCompletamentoInCorso" />
    </div>
  </Dialog>
  <Dialog 
    v-model:visible="dialogDelete" 
    modal 
    header="Conferma Cancellazione" 
    :style="{ width: '30rem' }"
  >
    <div class="p-fluid">
      <p>Sei sicuro di voler eliminare questa pratica?</p>
      <p v-if="praticaToDelete" class="mt-2">
        <strong>ID Pratica:</strong> {{ praticaToDelete.id }}<br>
        <strong>Codice:</strong> {{ praticaToDelete.codicepod || '-' }}
      </p>
      <p class="mt-2 text-red-500"><strong>Questa azione non può essere annullata.</strong></p>
    </div>
    <div class="dialog-footer" style="text-align: right; margin-top: 20px;">
      <Button label="Annulla" icon="pi pi-times" class="p-button-text" @click="dialogDelete = false" />
      <Button label="Elimina" icon="pi pi-trash" class="p-button-danger" @click="confermaDelete" />
    </div>
  </Dialog>
</template>

<script>
import { ref, onMounted, onUnmounted, watch, computed } from "vue";
import moment from "moment";
import Service from "@/services/ask-pratiche/gestione-pratiche";
import { useRoute } from "vue-router";
import * as XLSX from "xlsx";
import { useToast } from "primevue/usetoast";
import InputMask from "primevue/inputmask";
import NotaInvioDocumentazione from "./NotaInvioDocumentazione.vue";
import PreventivoFirmatoBox from "./PreventivoFirmatoBox.vue";
import SottostatiTimeline from "./SottostatiTimeline.vue";
import {
  isPreventivoFirmato,
  ordinaStati,
  preparaPreventivoFirmato,
  statiBasePreventivo,
  vedeSoloPreventivo,
  timelineFromStati,
} from "@/services/ask-pratiche/preventivoFirmato";
import AppuntamentoPratica from "./AppuntamentoPratica.vue";


export default {
  components: {
    AppuntamentoPratica,
    InputMask,
    NotaInvioDocumentazione,
    PreventivoFirmatoBox,
    SottostatiTimeline,
  },
  props: {
    data: Array,
    stati: Array,
  },
  setup(props) {
    const user = ref(null);
    const allowedIdUser = [6, 22, 32, 60, 49, 33];
    const route = useRoute();
    const toast = useToast();
    const get_id = route.params.id;
    const loader = ref(true);
    const service = new Service();
    const ModificaPosaContatore = ref([]);
    const filteredModificaPosaContatore = ref([]);
    const pagination = ref({
      current_page: 1,
      per_page: 30,
      total: 0,
      last_page: 1,
    });
    const cod_pod = ref("");
    const rappid = ref("");
    const clientid = ref("");
    const timelineData = ref([]);
    const newStati = ref([]);
    const timelineKey = ref(0);
    const dialoginfo = ref(false);
    const showSuccessAlert = ref(false);
    const showSuccessAlert2 = ref(false);
    const isActive = ref(false);
    const selectedpratica = ref({
      code: "",
      cod_pratica: "",
      privato: 1,
      value: {
        file: null,
      },
    });
    const types_stato_pratica = ref([]);
    const sortedStates = computed(() => {
      if (!selectedpratica.value || !selectedpratica.value.states) {
        return [];
      }
      return [...selectedpratica.value.states].sort((a, b) => {
        const dateA = a.data_nota ? new Date(a.data_nota) : null;
        const dateB = b.data_nota ? new Date(b.data_nota) : null;

        if (dateA && dateB) {
          return dateA - dateB; 
        }
        if (dateA && !dateB) return 1;
        if (!dateA && dateB) return -1;
        return 0;
      });
    });
    const selectedRows = ref([]);
    const massiveSelectedStatus = ref(null);
    const searchTerm = ref("");
    const statiDisponibili = ref([
      { stato: "TUTTI", value: "tutti" },
      { stato: "non lavorato", value: "non lavorato" },
      { stato: "Acquisizione", value: "Acquisizione" },
      { stato: "in lavorazione", value: "in lavorazione" },
      { stato: "prima pianificazione", value: "prima pianificazione" },
      { stato: "sopralluogo", value: "sopralluogo" },
      { stato: "preventivo", value: "preventivo" },
      { stato: "preventivo firmato", value: "preventivo firmato" },
      {
        stato: "adempimenti ed autorizzazioni",
        value: "adempimenti ed autorizzazioni",
      },
      { stato: "seconda pianificazione", value: "seconda pianificazione" },
      { stato: "esecuzione intervento", value: "esecuzione intervento" },
      { stato: "completamento", value: "completamento" },
      { stato: "ko", value: "ko" },
    ]);
    const selectedState = ref(null);
    const currentRecordIndex = ref(null);
    const preventivoDialog = ref(false);
    const importoPreventivo = ref(null);
    const dialogVisible = ref(false);
    const preventivoData = ref({
      cod_cliente: null,
      cod_pratica: null, 
      importo: null,
      stato: 0,
      type_pratica: 'ModificaPosaContatore',
      creation_time: null
    });
    const nuovaPratica = ref({
      statoPratica: "",
      telefono: "",
      dataInserimento: "",
      intestatario: "",
      partitaIva: "",
      email: "",
      ragionesociale: "",
      codiceFiscale: "",
      code: "",
      matricola: "",
      indirizzo: "",
      potenzaDisponibile: "",
      potenzaImpegnata: "",
      distributore: "",
      stagionalità: "",
      tipoConnessione: "",
      connessione: "",
      tensione: "",
      tipologiaContrattuale: "",
      disalimentabile: "",
      sedeLegale: "",
      categoria_uso: "",
      new_categoria_uso: "",
      udd: "",
      codicePratica: "",
      remi: "",
      connessioneGas: "",
      portataKwh: "",
      classeMisuratore: "",
      dataFineTemporanea: "",
      agente: null,
    });
    const preventivoEsistente = ref(null);

    const currentDate = new Date();
    const defaultDate = ref(
      currentDate.toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      })
    );
    const connessioneOptions = ref([
      "A01_Attivazione su Preposato a parità di condizioni di connessione",
      "A03_Attivazione su Preposato con Modifica di condizioni di connessione",
      "N01_Nuova Connessione Senza Attivazione",
      "N02_Nuova Connessione Con Attivazione",
    ]);
    const tensioneOptions = ref([
      "BT MONOFASE 220V",
      "BT TRIFASE 380V",
      "MT",
      "AT / AAT",
    ]);
    const tipologiaUsoOptions = ref([
      "Ordinaria",
      "Cottimo",
      "Installazione non presidiata in permanenza, situata fuori dagli abitati",
      "Insegne luminose e pubblicitarie",
      "Impianto di illuminazione di monumenti e simili",
      "Impianto di risalita e simili",
      "Installazione mobili e precarie (roulottes e simili) situate fuori dai centri abitati o sprovviste della concessione dioccupazione",
      "Singola costruzione non abitata in permanenza o comunque non di residenza anagrafica del proprietario (ville, case di caccia, etc)",
      "Costruzione che non sia raggiungibile con strada percorribile da automezzi o che sia separata dagli impianti di distribuzione",
      "Cantiere",
      "Spettacolo viaggiante e simili",
      "Impianto realizzato in occasioni di manifestazioni e feste patronali, popolari, politiche, religiose, sportive, teatrali e simili",
      "Impianto relativo a riprese cinematografiche, televisive e simili",
      "Fornitura Temporanea diversa da cantiere con contributo non agevolato",
    ]);

    const tipologiaContrattualeOptions = ref([
      "Altri Usi",
      "Domestico Non Residente",
      "Domestico Residente",
      "Illuminazione Pubblica",
    ]);
    const disalimentabileOptions = ref([
      "Si",
      "No",
      "Presenti apparecchiature mediche per l'esistenza in vita alimentate ad en. el.",
      "Fornitura di pubblica utilità art. 18.1 c) Del. AEEG 04/08",
    ]);

    const connessioneGasOptions = ref([
      "PN1 - Preventivo Nuovo Impianto",
      "PM1 - Preventivo Modifica Impianto",
      "PR1 - Preventivo Rimozione Impianto",
    ]);

    const classeMisuratoreOptions = ref([
      "G4",
      "⁠⁠G6",
      "⁠⁠G10",
      "⁠⁠G16",
      "⁠⁠G25",
      "⁠⁠G40",
      "⁠⁠G65",
      "⁠⁠G100",
      "⁠⁠G160",
      "⁠⁠G250",
      "⁠⁠G400",
      "⁠⁠G650",
    ]);

    const activeFilter = ref(null);
    const filteredAgents = ref([]);
    const tableContainerRef = ref(null);

    const handleKeyDown = (event) => {
      if (!tableContainerRef.value) return;
      
      const activeElement = document.activeElement;
      const isEditableElement = activeElement.tagName === 'INPUT' || 
                                activeElement.tagName === 'TEXTAREA' || 
                                activeElement.contentEditable === 'true';
      
      const isInDialog = activeElement.closest('.p-dialog') !== null;
      
      if (isEditableElement || isInDialog) return;

      const scrollAmount = 150;
      
      let scrollableElement = tableContainerRef.value;
      const dataTableWrapper = tableContainerRef.value.querySelector('.p-datatable-wrapper');
      if (dataTableWrapper) {
        scrollableElement = dataTableWrapper;
      }
      
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        scrollableElement.scrollBy({
          left: -scrollAmount,
          behavior: 'smooth'
        });
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        scrollableElement.scrollBy({
          left: scrollAmount,
          behavior: 'smooth'
        });
      }
    };

    const onSearch = () => {
      loadPage(1);
    };

    let fetchFilesInterval = null;

    onMounted(async () => {
      types_stato_pratica.value = ordinaStati(props.stati);
      newStati.value = [...types_stato_pratica.value];

      if (props.data && Array.isArray(props.data.files)) {
        const initial = props.data;

        if (initial.pagination) {
          pagination.value = {
            current_page: initial.pagination.current_page || 1,
            per_page: initial.pagination.per_page || 30,
            total: initial.pagination.total || initial.files.length,
            last_page: initial.pagination.last_page || 1,
          };
        } else {
          pagination.value = {
            current_page: 1,
            per_page: 30,
            total: initial.files.length,
            last_page: 1,
          };
        }

        await fetchUploadedFiles(initial.files);
        await fetchCurrentStatus(initial.files);
      }

      fetchTimelineData(props.stati);
      searchAgents();
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        user.value = JSON.parse(atob(storedUser)).user[0];
      }

      setActiveFilter("pod");
      // fetchFilesInterval = setInterval(fetchUploadedFiles, 5 * 60 * 1000);
      
      window.addEventListener('keydown', handleKeyDown);
    });

    onUnmounted(() => {
      if (fetchFilesInterval) {
        clearInterval(fetchFilesInterval);
      }
      if (ricercaMatriceTimer) {
        clearTimeout(ricercaMatriceTimer);
      }
      window.removeEventListener('keydown', handleKeyDown);
    });

    const fetchUploadedFiles = async (data) => {
      try {
        // const filesResponse = await service.getListModificaPosaContatore();
        const filesResponse = data || [];
        const existingFiles = ModificaPosaContatore.value;

        filesResponse.forEach((file) => {
          if (!file.NomeCliente) {
            file.NomeCliente = file.nomerappresentante;
          }
          if (!file.CognomeCliente) {
            file.CognomeCliente = file.cognomerappresentante;
          }

          const existingFileIndex = existingFiles.findIndex(
            (existing) => existing.id === file.id
          );

          if (existingFileIndex !== -1) {
            existingFiles[existingFileIndex] = {
              ...existingFiles[existingFileIndex],
              ...file,
              created_at: moment(file.data).format("YYYY-MM-DD HH:mm:ss"),
              isTimelineVisible: false,
              uniqueId: existingFiles[existingFileIndex].uniqueId,
            };
          } else {
            existingFiles.push({
              ...file,
              created_at: moment(file.data).format("YYYY-MM-DD HH:mm:ss"),
              isTimelineVisible: false,
              uniqueId: existingFiles.length + 1,
            });
          }
        });

        ModificaPosaContatore.value = existingFiles;

        if (get_id) {
          filteredModificaPosaContatore.value = existingFiles.filter(
            (item) => item.id == get_id
          );
        } else {
          filteredModificaPosaContatore.value = existingFiles.filter(
            (item) =>
              item.uploaded === "yes" &&
              item.ultimo_stato !== "completamento"
          );
        }

        loader.value = false;
      } catch (error) {
        console.error("Errore durante il recupero dei file:", error);
        loader.value = false;
      }
    };

    const statiSoloPreventivo = computed(() => statiBasePreventivo(newStati.value));
    const statiMassivi = computed(() =>
      (newStati.value || []).filter((stato) => !isPreventivoFirmato(stato))
    );
    const impostaFilePreventivoFirmato = (file) => {
      if (selectedpratica.value) {
        selectedpratica.value.filePreventivoFirmato = file;
      }
    };

    const applyMassiveStatusChange = async () => {
      if (isPreventivoFirmato(massiveSelectedStatus.value)) {
        toast.add({
          severity: "error",
          summary: "File obbligatorio",
          detail: "Il preventivo firmato va caricato sulla singola pratica.",
          life: 4000,
        });
        return;
      }
      if (!massiveSelectedStatus.value || selectedRows.value.length === 0) {
        return;
      }

      for (let i = 0; i < selectedRows.value.length; i++) {
        const row = selectedRows.value[i];
        const plainRow = JSON.parse(JSON.stringify(row));

        plainRow.selectedStato = massiveSelectedStatus.value;
        service.syncPrivateByNote(plainRow);
        plainRow.tipologia = plainRow.tipologia || "ModificaPosaContatore";

        await inviaNota(plainRow, "ModificaPosaContatore");
      }

      selectedRows.value = [];
      massiveSelectedStatus.value = null;

      await fetchUploadedFiles();
    };

    const rimuoviFiltroStato = () => {
      if (isActive.value) {
        filteredModificaPosaContatore.value =
          ModificaPosaContatore.value.filter((item) => item.uploaded === "yes");
      } else {
        filteredModificaPosaContatore.value =
          ModificaPosaContatore.value.filter(
            (item) =>
              item.uploaded === "yes" &&
              item.ultimo_stato !== "completamento"
          );
      }
      isActive.value = !isActive.value;
    };

    const fetchTimelineData = async (stati) => {
      try {
        // const response = await service.getStatoPratica();
        if (stati && Array.isArray(stati) && stati.length > 0) {
          timelineData.value = timelineFromStati(stati);
        } else {
          console.error(
            "La risposta dell'API non contiene i dati attesi:",
            stati
          );
        }
      } catch (error) {
        console.error(
          "Errore durante il recupero dei dati della timeline:",
          error
        );
      }
    };

    const fetchCurrentStatus = async (data) => {
      try {
        // const filesResponse = await service.getListModificaPosaContatore();
        const filesResponse = data || [];
        if (!filesResponse.length) {
          console.warn("Nessun dato in filesResponse per fetchCurrentStatus");
          return;
        }
        const formattedFiles = filesResponse.map((file, index) => ({
          ...file,
          created_at: moment(file.data).format("YYYY-MM-DD HH:mm:ss"),
          isTimelineVisible: false,
          uniqueId: index + 1,
          cod_type_stato_pratica: file.ultimo_cod_type_stato_pratica,
        }));
        ModificaPosaContatore.value = formattedFiles;

        formattedFiles.forEach((pratica) => {
          const timelineItemIndex = timelineData.value.findIndex(
            (item) => item.numero === pratica.cod_type_stato_pratica
          );
          if (timelineItemIndex !== -1) {
            timelineData.value[timelineItemIndex].colore = "blue";
          }
        });
      } catch (error) {
        console.error("Errore durante il recupero dei file:", error);
      } finally {
        loader.value = false;
      }
    };

    const searchAgents = async (event = null) => {
      
      if (!event) {
        filteredAgents.value = await service.getAgentiSuggeriti('');
      } else {
        const query = event.query.toLowerCase().trim();
        filteredAgents.value = await service.getAgentiSuggeriti(query);
      }

    };

    const statoToIdMap = {
      Acquisizione: 1,
      "in lavorazione": 2,
      "prima pianificazione": 3,
      sopralluogo: 4,
      preventivo: 5,
      "adempimenti ed autorizzazioni": 6,
      "seconda pianificazione": 7,
      "esecuzione intervento": 8,
      completamento: 9,
    };

    const changePraticaStatus = async (pratica) => {
      service.syncPrivateByNote(pratica);

      try {
        const statoId =
          pratica.selectedStato.id ??
          pratica.selectedStato.numero ??
          statoToIdMap[pratica.selectedStato.stato];
        if (statoId === undefined) {
          console.error("Stato non mappato:", pratica.selectedStato.stato);
        }
      } catch (error) {
        console.error(
          "Errore durante la gestione del cambio di stato della pratica:",
          error
        );
      }
    };

    const openInfoDialog = async (data, index) => {
      try {
        dialoginfo.value = true;
        selectedpratica.value = {
          ...data,
          privato: 1,
          id: data.id,
          clientid: data.clientid || data.client_id || data.id_cliente,
          client_id: data.clientid || data.client_id || data.id_cliente,
          nomerappresentante: data.nomerappresentante || data.NomeCliente || '',
          cognomerappresentante: data.cognomerappresentante || data.CognomeCliente || '',
          numero_telefono: data.numero_telefono || data.telefono || '',
          codiceFiscale: data.codiceFiscale || data.codice_fiscale || '',
          ragsoc: data.ragsoc || data.ragionesociale || '',
          code: data.code || data.codicepod || " - ",
          podid: data.podid,
          rappid: data.rappid,
          codecliente: data.codecliente,
          intestatario: data.intestatario,
          name: data.name, 
          ragionesociale: data.ragionesociale,
          codicepod: data.codicepod
        };

        currentRecordIndex.value = index;

        const response = await service.getStatusPratica(
          data.id,
          "ModificaPosaContatore"
        );
        if (response && response.stati && response.stati.length > 0) {
          const ModificaPosaContatoreStates = response.stati.filter(
            (state) =>
              state.type_file === "ModificaPosaContatore" &&
              state.cod_pratica === data.id
          );

          if (ModificaPosaContatoreStates.length > 0) {
            selectedpratica.value.states = ModificaPosaContatoreStates;
            selectedpratica.value.stato_pratica =
              ModificaPosaContatoreStates[0].stato_corrispondente;
              selectedpratica.value.stato_corrispondente = ModificaPosaContatoreStates[0].stato_corrispondente;
              selectedpratica.value.cod_type_stato_pratica = ModificaPosaContatoreStates[0].cod_type_stato_pratica;
              timelineKey.value += 1;
          } else {
            selectedpratica.value.states = [];
          }
        }

        try {
          const responsePreventivo = await service.getPreventivoPratica(data.id, 'ModificaPosaContatore');
          preventivoEsistente.value = responsePreventivo.data;
        } catch (error) {
          preventivoEsistente.value = null;
        }
      } catch (error) {
        console.error("Errore durante il recupero dello stato della pratica:", error);
        selectedpratica.value.states = [];
      }
    };

    const inviaNota = async (rowData, typefile = "ModificaPosaContatore") => {
      try {
        service.syncPrivateByNote(rowData);

        if (rowData.selectedStato?.stato === "completamento") {
          praticaInCompletamento.value = rowData;
          codeCompletamento.value = "";
          matriceSuggerita.value = null;
          ricercaMatriceInCorso.value = false;
          ricercaMatriceCompletata.value = false;
          salvataggioCompletamentoInCorso.value = false;
          ultimaRicercaMatriceKey = "";
          dialogCompletamento.value = true;
          return; 
        }

        const preventivoOk = await preparaPreventivoFirmato({
          service,
          row: rowData,
          typeFile: typefile,
          toast,
          lista: ModificaPosaContatore.value,
        });
        if (!preventivoOk) {
          return;
        }

        await inviaNotaBase(rowData, typefile);

      
        return true;
      } catch (error) {
        console.error("Errore durante l'aggiornamento della nota:", error);
        return false;
      }
    }


    const ricaricaDialogStato = async () => {
      if (!selectedpratica.value?.id) return;
      await openInfoDialog(selectedpratica.value, currentRecordIndex.value);
    };

    const faseInvioStato = ref("");
    const inviaStatoAnimato = async (...argomenti) => {
      if (faseInvioStato.value === "invio") {
        return;
      }
      faseInvioStato.value = "invio";
      let ok = false;
      try {
        ok = Boolean(await inviaNota(...argomenti));
      } catch (error) {
        ok = false;
      }
      if (ok) {
        try {
          await ricaricaDialogStato();
        } catch (error) {
          console.error("Errore durante il ricaricamento della pratica:", error);
        }
      }
      faseInvioStato.value = ok ? "inviato" : "";
      if (ok) {
        setTimeout(() => {
          faseInvioStato.value = "";
        }, 1400);
      }
    };

    const inviaNotaBase = async (rowData, typefile = "ModificaPosaContatore") => {
      if (!rowData || !rowData.id) {
        console.warn("Dati non validi per la pratica.");
        return;
      }

      service.syncPrivateByNote(rowData);
      const privato = rowData.privato ? 1 : 0;
      const partiNome = [];

      if (rowData.nomerappresentante || rowData.cognomerappresentante) {
        const nomeCognome = `${rowData.nomerappresentante || ""} ${rowData.cognomerappresentante || ""}`.trim();
        if (nomeCognome) partiNome.push(nomeCognome);
      }

      if (rowData.intestatario) {
        partiNome.push(rowData.intestatario);
      }

      if (rowData.ragionesociale || rowData.ragsoc) {
        partiNome.push(rowData.ragionesociale || rowData.ragsoc);
      }

      const nomeCompleto =
        partiNome.length > 0
          ? partiNome.join(" - ")
          : rowData.name
            ? rowData.name
            : "Nome completo non disponibile";

      await service.aggiornaNotePratica({
        id_pratica: rowData.id,
        nota: rowData.nota || "",
        new_status: rowData.selectedStato,
        stato_nome: rowData.selectedStato?.stato || "Stato non specificato",
        nome_completo: nomeCompleto,
        privato: privato,
        typefile: typefile,
        code: rowData.codicepod,
        tipologia: "ModificaPosaContatore",
      });

      rowData.nota = "";
      rowData.selectedStato = null;
      rowData.privato = privato;
    };

    const notificaConfigurazioneMatriceMancante = (response) => {
      if (!response?.configurazione_mancante) return;

      toast.add({
        severity: 'warn',
        summary: 'Configurazione mancante',
        detail: response.messaggio_matrice || 'La matrice non puo essere associata alla nuova posa',
        life: 5000
      });
    };

    const eseguiAvanzamentoMatriceNuovaPosa = async (matrice) => {
      if (!matrice?.matrice_id || matrice.skipped) return;

      const actions = Array.isArray(matrice.advance_actions)
        ? matrice.advance_actions
        : [];

      if (actions.includes("autovalidazione")) {
        await service.autovalidaCaricamentoById(matrice.matrice_id);
      }

      if (actions.includes("caricamento")) {
        const response = await service.forzaCaricamento(matrice.matrice_id);
        if (response?.success === false) {
          throw new Error(response.errore || "Errore durante il caricamento forzato");
        }
      }
    };

    const confermaCompletamento = async () => {
      if (salvataggioCompletamentoInCorso.value) return;

      try {
        salvataggioCompletamentoInCorso.value = true;
        const code = String(codeCompletamento.value || "").trim().toUpperCase();
        const tipo = String(
          praticaInCompletamento.value?.tipo ||
          praticaInCompletamento.value?.tipoPratica ||
          ""
        ).toLowerCase();
        const codeValido = tipo === "gas"
          ? /^\d{14}$/.test(code)
          : /^IT\d{3}E\d{7}[0-9A]$/.test(code);

        if (!codeValido) {
          toast.add({
            severity: 'error',
            summary: 'Errore',
            detail: tipo === "gas"
              ? 'Inserire un code Gas completo di 14 cifre'
              : 'Inserire un code Elettrico completo nel formato richiesto',
            life: 3000
          });
          return;
        }

        if (!dataCompletamento.value) {
          toast.add({
            severity: 'error',
            summary: 'Errore',
            detail: 'Inserire la data di completamento',
            life: 3000
          });
          return;
        }

        const rowData = praticaInCompletamento.value;
        const dataFormattata = moment(dataCompletamento.value).format('YYYY-MM-DD');

        const updateCodeResponse = await service.updateCodePosaContatore(
          rowData.id,
          code,
          true,
          tipo === "gas" ? "Gas" : "Elettrico"
        );
        rowData.codicepod = code;
        rowData.code = code;
        notificaConfigurazioneMatriceMancante(updateCodeResponse);

        if (updateCodeResponse?.matrice_associata) {
          await eseguiAvanzamentoMatriceNuovaPosa(updateCodeResponse.matrice);
        }

        service.syncPrivateByNote(rowData);
        const privato = rowData.privato ? 1 : 0;
        const partiNome = [];

        if (rowData.nomerappresentante || rowData.cognomerappresentante) {
          const nomeCognome = `${rowData.nomerappresentante || ""} ${rowData.cognomerappresentante || ""}`.trim();
          if (nomeCognome) partiNome.push(nomeCognome);
        }

        if (rowData.intestatario) {
          partiNome.push(rowData.intestatario);
        }

        if (rowData.ragionesociale || rowData.ragsoc) {
          partiNome.push(rowData.ragionesociale || rowData.ragsoc);
        }

        const nomeCompleto =
          partiNome.length > 0
            ? partiNome.join(" - ")
            : rowData.name
              ? rowData.name
              : "Nome completo non disponibile";

        await service.aggiornaNotePratica({
          id_pratica: rowData.id,
          nota: rowData.nota || "",
          new_status: rowData.selectedStato,
          stato_nome: rowData.selectedStato?.stato || "Stato non specificato",
          nome_completo: nomeCompleto,
          privato: privato,
          typefile: "ModificaPosaContatore",
          code: rowData.codicepod,
          tipologia: "ModificaPosaContatore"
        });

        await service.completamentoPosaContatore(
          rowData.id,
          "ModificaPosaContatore",
          dataFormattata
        );

        rowData.nota = "";
        rowData.selectedStato = null;
        rowData.privato = privato;
        dialogCompletamento.value = false;
        dataCompletamento.value = null;
        codeCompletamento.value = "";
        matriceSuggerita.value = null;
        ricercaMatriceCompletata.value = false;
        praticaInCompletamento.value = null;

        toast.add({
          severity: 'success',
          summary: 'Successo',
          detail: 'Pratica completata con successo',
          life: 3000
        });

      } catch (error) {
        console.error("Errore durante il completamento della pratica:", error);
        toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore durante il completamento della pratica',
          life: 3000
        });
      } finally {
        salvataggioCompletamentoInCorso.value = false;
      }
    };

    const handleButtonClick = (data) => {
      window.open(`/ask/pods/${data.cod_pod}/dettagli`);
    };

    const handleButtonClick2 = (rappidValue) => {
      window.open(`/ask/rappresentanti/${rappidValue}/dettagli`);
    };

    const handleButtonClick3 = (clientidValue) => {
      window.open(`/ask/clienti/${clientidValue}/dettagli`);
    };

    const startEditing = (rowData) => {
      rowData.isEditing = true;
    };

    const normalizeText = (value) => String(value ?? "").trim().toLowerCase();

    const canEditCode = (rowData) => {
      const codeIsEmpty = rowData?.codicepod === null || rowData?.codicepod === undefined;
      return codeIsEmpty && normalizeText(rowData?.ultimo_stato) === "completamento";
    };

    const startCodeEditing = (rowData) => {
      if (!canEditCode(rowData)) return;

      rowData.isEditingCode = true;
    };

    const stopCodeEditing = async (rowData) => {
      if (!rowData?.isEditingCode) return;

      const nextCode = String(rowData.codicepod ?? "").trim().toUpperCase();
      const tipo = String(rowData?.tipo || rowData?.tipoPratica || "").toLowerCase();

      try {
        rowData.isEditingCode = false;

        if (!nextCode) return;

        const updateCodeResponse = await service.updateCodePosaContatore(
          rowData.id,
          nextCode,
          true,
          tipo === "gas" ? "Gas" : "Elettrico"
        );
        rowData.codicepod = nextCode;
        rowData.code = nextCode;
        notificaConfigurazioneMatriceMancante(updateCodeResponse);

        if (updateCodeResponse?.matrice_associata) {
          await eseguiAvanzamentoMatriceNuovaPosa(updateCodeResponse.matrice);
        }
      } catch (error) {
        console.error("Errore durante l'aggiornamento del Code:", error);
      }
    };

    const stopEditing = async (rowData) => {
      try {
        rowData.isEditing = false;

        await service.aggiungiUddECodicePratica(
          rowData.id,
          rowData.udd,
          rowData.codicePratica,
          rowData.distributore,
          'posa' 
        );
      } catch (error) {
        console.error(
          "Errore durante l'aggiornamento di UDD e Codice Pratica:",
          error
        );
      }
    };

    const handleFileChange = async (event) => {
      const fileInput = event.target;
      const fileLabel = document.getElementById("fileLabel2");

      if (fileInput.files.length > 0) {
        const file = fileInput.files[0];
        const fileName = file.name;
        try {
          fileLabel.innerHTML = `<i class="fas fa-cloud-upload-alt"></i> ${fileName}`;
          await uploadPreventiviPratiche(file);
          showSuccessAlert.value = true;

          setTimeout(() => {
            showSuccessAlert.value = false;
            fileLabel.innerHTML = `<i class="fas fa-cloud-upload-alt"></i> Carica Preventivo`;
          }, 3000);
        } catch (error) {
          console.error("Errore durante il caricamento del file:", error);
        }
      } else {
        fileLabel.innerHTML = `<i class="fas fa-cloud-upload-alt"></i> Carica Preventivo`;
      }
    };

    const handleUploadPratiche = async (event) => {
      const fileInput = event.target;
      const fileLabel = document.getElementById("fileLabel1");

      if (fileInput.files.length > 0) {
        const file = fileInput.files[0];
        const fileName = file.name;
        try {
          fileLabel.innerHTML = `<i class="fas fa-cloud-upload-alt"></i> ${fileName}`;
          await uploadAllegatiPratiche(file);
          showSuccessAlert2.value = true;

          setTimeout(() => {
            showSuccessAlert2.value = false;
            fileLabel.innerHTML = `<i class="fas fa-cloud-upload-alt"></i> Carica Allegato`;
          }, 3000);
        } catch (error) {
          console.error("Errore durante il caricamento del file:", error);
        }
      } else {
        fileLabel.innerHTML = `<i class="fas fa-cloud-upload-alt"></i> Carica Allegato`;
      }
    };

    const uploadAllegatiPratiche = async (file) => {
      try {
        const selectedPratica = selectedpratica.value;
        if (!selectedPratica || !selectedPratica.id || !file) {
          throw new Error("File non trovato nella pratica selezionata.");
        }

        const requestData = {
          id: selectedPratica.id,
          file: file,
        };

        const response = await service.uploadAllegatiPratichePosaContatore(
          requestData
        );

        if (
          response &&
          response.message === "File caricati con successo sull'FTP"
        ) {
          console.log("Caricamento effettuato con successo:", response);
        } else {
          console.error("Errore durante il caricamento del file:", response);
          throw new Error("Errore durante il caricamento del file.");
        }
        return response;
      } catch (error) {
        console.error("Errore durante il caricamento del file:", error);
        throw error;
      }
    };

    const downloadAllegatoPratica = async (id) => {
      try {
        if (!id) {
          throw new Error("ID non valido.");
        }



        await service.downloadAllegatoPraticaPosaContatore(id);
      } catch (error) {
        document.getElementById("error-alert").style.display = "block";
        console.error("Errore durante il download del Allegato:", error);
        setTimeout(() => {
          document.getElementById("error-alert").style.display = "none";
        }, 3000);
        throw error;
      }
    };

    const chooseFile = () => {
      document.getElementById("fileInput").click();
    };

    const uploadPreventiviPratiche = async (file) => {
      try {
        const selectedPratica = selectedpratica.value;
        if (!selectedPratica || !selectedPratica.id || !file) {
          throw new Error("File non trovato nella pratica selezionata.");
        }

        const requestData = {
          id: selectedPratica.id,
          tipo: "PosaContatore",
          file: file,
        };
        const response = await service.uploadPreventiviPratiche(requestData);

        if (
          response &&
          response.message === "File caricati con successo sull'FTP"
        ) {
          console.log("Caricamento effettuato con successo:", response);
        } else {
          console.error("Errore durante il caricamento del file:", response);
          throw new Error("Errore durante il caricamento del file.");
        }
        return response;
      } catch (error) {
        console.error("Errore durante il caricamento del file:", error);
        throw error;
      }
    };

    const downloadPreventivoPratica = async (id) => {
      try {
        const tipo = "PosaContatore";
        await service.downloadPreventivoPratica(id, tipo);
      } catch (error) {
        document.getElementById("error-alert").style.display = "block";
        console.error("Errore durante il download del preventivo:", error);
        setTimeout(() => {
          document.getElementById("error-alert").style.display = "none";
        }, 3000);
        throw error;
      }
    };

    const showFileUploadButton = () => {
      return true;
    };

    const aggiungiPratica = () => {
      dialogVisible.value = true;
    };

    const uddEditor = {
      template: '<InputText v-model="rowData.udd" />',
    };

    const codicePraticaEditor = {
      template: '<InputText v-model="rowData.codicePratica" />',
    };

    const aggiungiPraticaConferma = async () => {
      let agenteId = null;
      
      if (nuovaPratica.value.agente) {
        const agenteCopy = JSON.parse(JSON.stringify(nuovaPratica.value.agente));
        agenteId = agenteCopy.id ? Number(agenteCopy.id) : null;
      }

      const nuovaPraticaObj = {
        id: nuovaPratica.value.id || "",
        code: nuovaPratica.value.code || "",
        matricola: nuovaPratica.value.matricola || "",
        udd: nuovaPratica.value.udd || "",
        codicePratica: nuovaPratica.value.codicePratica || "",
        ragionesociale: nuovaPratica.value.ragionesociale || "",
        codiceFiscale: nuovaPratica.value.codiceFiscale || "",
        partitaIva: nuovaPratica.value.partitaIva || "",
        email: nuovaPratica.value.email || "",
        nomerappresentante: nuovaPratica.value.nomerappresentante || "",
        cognomerappresentante: nuovaPratica.value.cognomerappresentante || "",
        telefono: nuovaPratica.value.telefono || "",
        intestatario: nuovaPratica.value.intestatario || "",
        potenzaDisponibile: nuovaPratica.value.potenzaDisponibile || "",
        potenzaImpegnata: nuovaPratica.value.potenzaImpegnata || "",
        stagionalità: nuovaPratica.value.stagionalità || "",
        tensione: nuovaPratica.value.tensione || "",
        tipologiaContrattuale: nuovaPratica.value.tipologiaContrattuale || "",
        distributore: nuovaPratica.value.distributore || "",
        categoria_uso: nuovaPratica.value.new_categoria_uso || nuovaPratica.value.categoria_uso || "",
        new_categoria_uso: nuovaPratica.value.new_categoria_uso || "",
        tipoConnessione: nuovaPratica.value.tipoConnessione || "",
        connessione: nuovaPratica.value.connessione || "",
        sedeLegale: nuovaPratica.value.sedeLegale || "",
        disalimentabile: nuovaPratica.value.disalimentabile || "",
        remi: nuovaPratica.value.remi || "",
        connessioneGas: nuovaPratica.value.connessioneGas || "",
        portataKwh: nuovaPratica.value.portataKwh || "",
        indirizzo: nuovaPratica.value.indirizzo || "",
        classeMisuratore: nuovaPratica.value.classeMisuratore || "",
        tipoPratica: nuovaPratica.value.tipoPratica || "",
        dataFineTemporanea: nuovaPratica.value.dataFineTemporanea || "",
        tipologiauso: nuovaPratica.value.tipologiauso || "",
        agente_id: agenteId,
      };

      


      try {
        await service.aggiungiPraticaConfermaModificaPosaContatore(
          nuovaPraticaObj
        );

        filteredModificaPosaContatore.value.push(nuovaPraticaObj);
        showSuccessAlert.value = true;
        dialogVisible.value = false;

        setTimeout(() => {
          showSuccessAlert.value = false;
        }, 3000);
      } catch (error) {
        console.error("Errore durante l'aggiunta della pratica:", error);
      }
    };

    const exportToExcel = async () => {
      try {
        loader.value = true;

        let sourceData = [];

        if (allCurrentPageSelected.value) {
          const statoFilter = selectedState.value
            ? selectedState.value.value
            : null;

          const search = searchTerm.value && searchTerm.value.trim() !== ""
            ? searchTerm.value.trim()
            : null;

          const response = await service.getListModificaPosaContatore(
            1,
            999999,
            statoFilter,
            search
          );

          let allItems = response?.files || [];

          if (activeFilter.value === "pod") {
            allItems = allItems.filter(
              (item) =>
                item.tipo &&
                typeof item.tipo === "string" &&
                item.tipo.toLowerCase() === "elettrico"
            );
          } else if (activeFilter.value === "pdr") {
            allItems = allItems.filter(
              (item) =>
                item.tipo &&
                typeof item.tipo === "string" &&
                item.tipo.toLowerCase() === "gas"
            );
          }

          sourceData = allItems;
        } else {
          sourceData = selectedRows.value;
        }

        if (!sourceData.length) {
          toast.add({
            severity: "warn",
            summary: "Attenzione",
            detail: "Nessun dato da esportare",
            life: 3000,
          });
          return;
        }

        const dataToExport = sourceData.map((item) => ({
          Nome: item.nomerappresentante || "",
          Cognome: item.cognomerappresentante || "",
          Indirizzo: item.indirizzo || "",
          "Ragione Sociale": item.ragionesociale || "",
          "Sede Legale": item.sede_legale || "",
          Intestatario: item.intestatario || "",
          "Codice Fiscale": item.codice_fiscale || "",
          "Partita IVA": item.partita_iva || "",
          Email: item.email || "",
          "Codice Pod": item.codicepod || "",
          UDD: item.udd || "",
          "Codice Pratica": item.codicePratica || "",
          Telefono: item.numero_telefono || "",
          "Tipo Attivazione": item.new_attivazione || "",
          "Potenza Impegnata Richiesta": item.new_potenza_impegnata || "",
          "Potenza Disponibile Richiesta": item.new_potenza_disponibile || "",
          "Tensione Richiesta": item.new_tensione || "",
          "Tipologia Uso": item.tipologiauso || "",
          Disalimentabile: item.new_disalimentabile || "",
          "Tipo Contratto Richiesto": item.new_type_contratto || "",
          "Tipo Connessione": item.new_type_connessione || "",
          Stagionalità: item.new_stagionalità || "",
          Distributore: item.distributore || "",
          Remi: item.remi || "",
          Connessione: item.connessione || "",
          "Portata Kwh": item.portata_kwh || "",
          "Classe Misuratore": item.classe_misuratore || "",
          "Data temporanea": item.data_temporanea || "",
          "Tipo Pratica": item.tipo || "",
          Agente: item.agente || "",
          "Ultimo Stato": item.ultimo_stato || "",
          "Data Ultimo Stato": item.data_ultima_nota || "",
          "Ultima Nota": item.ultima_nota || "",
        }));

        const worksheet = XLSX.utils.json_to_sheet(dataToExport);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
          workbook,
          worksheet,
          "ModificaPosaContatore"
        );

        XLSX.writeFile(workbook, "Modifica_Posa_Contatore.xlsx");

        toast.add({
          severity: "success",
          summary: "Successo",
          detail: "Export completato correttamente",
          life: 3000,
        });
      } catch (error) {
        console.error("Errore durante l'export:", error);
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Errore durante l'esportazione",
          life: 3000,
        });
      } finally {
        loader.value = false;
      }
    };

    const filterByPOD = () => {
      let filtered = ModificaPosaContatore.value.filter(
        (item) =>
          item.tipo &&
          typeof item.tipo === "string" &&
          item.tipo.toLowerCase() === "elettrico"
      );
      
      if (selectedState.value && selectedState.value.value !== "tutti") {
        if (selectedState.value.value === "non lavorato") {
          filtered = filtered.filter((item) => !item.ultimo_stato);
        } else {
          filtered = filtered.filter(
            (item) => item.ultimo_stato === selectedState.value.value
          );
        }
      }
      
      filteredModificaPosaContatore.value = filtered;
    };

    const filterByPDR = () => {
      let filtered = ModificaPosaContatore.value.filter(
        (item) =>
          item.tipo &&
          typeof item.tipo === "string" &&
          item.tipo.toLowerCase() === "gas"
      );
      
      if (selectedState.value && selectedState.value.value !== "tutti") {
        if (selectedState.value.value === "non lavorato") {
          filtered = filtered.filter((item) => !item.ultimo_stato);
        } else {
          filtered = filtered.filter(
            (item) => item.ultimo_stato === selectedState.value.value
          );
        }
      }
      
      filteredModificaPosaContatore.value = filtered;
    };

    const filterByUltimoStato = () => {
      loadPage(1);
    };

    const setActiveFilter = (filter) => {
      activeFilter.value = filter;
      if (filter === "pod") {
        filterByPOD();
      } else if (filter === "pdr") {
        filterByPDR();
      } else {
        filteredModificaPosaContatore.value = ModificaPosaContatore.value;
      }
    };

    const loadPage = async (page) => {
      try {
        loader.value = true;
        const statoFilter = selectedState.value
          ? selectedState.value.value
          : null;

        const search = searchTerm.value && searchTerm.value.trim() !== ""
          ? searchTerm.value.trim()
          : null;

        const response = await service.getListModificaPosaContatore(
          page,
          pagination.value.per_page,
          statoFilter,
          search
        );

        if (response && Array.isArray(response.files)) {
          if (response.pagination) {
            pagination.value = {
              current_page: response.pagination.current_page || page,
              per_page: response.pagination.per_page || pagination.value.per_page,
              total: response.pagination.total || response.files.length,
              last_page: response.pagination.last_page || pagination.value.last_page,
            };
          } else {
            pagination.value = {
              current_page: page,
              per_page: pagination.value.per_page,
              total: response.files.length,
              last_page: pagination.value.last_page,
            };
          }

          await fetchUploadedFiles(response.files);
          await fetchCurrentStatus(response.files);

          // applica solo filtro POD/PDR lato client
          if (activeFilter.value === "pod") {
            filterByPOD();
          } else if (activeFilter.value === "pdr") {
            filterByPDR();
          } else {
            filteredModificaPosaContatore.value = ModificaPosaContatore.value;
          }
        }
      } catch (error) {
        console.error("Errore durante il caricamento della pagina:", error);
      } finally {
        loader.value = false;
      }
    };

    const onPage = (event) => {
      const nextPage = event.page + 1;
      pagination.value.per_page = event.rows;
      loadPage(nextPage);
    };

    const openPreventivo = () => {
      preventivoDialog.value = true;
    };

    const generaPreventivo = async () => {
      try {
        if (!importoPreventivo.value) {
          toast.add({
            severity: 'error',
            summary: 'Errore',
            detail: 'Importo preventivo non specificato',
            life: 3000
          });
          return;
        }

        const clientId = selectedpratica.value?.clientiid || 
                        selectedpratica.value?.id_cliente || 
                        selectedpratica.value?.clientid;

        preventivoData.value = {
          cod_cliente: clientId,
          cod_pratica: selectedpratica.value.id,
          importo: Number(importoPreventivo.value),
          stato: 0,
          type_pratica: 'ModificaPosaContatore',
          creation_time: new Date().toISOString()
        };


        await service.salvaPreventivoPartica(preventivoData.value);

        preventivoDialog.value = false;
        importoPreventivo.value = null;

        toast.add({
          severity: 'success',
          summary: 'Successo',
          detail: 'Preventivo salvato correttamente',
          life: 3000
        });

      } catch (error) {
        console.error("Errore completo durante la generazione del preventivo:", error);
        toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore durante il salvataggio del preventivo',
          life: 3000
        });
      }
    };

    watch(selectedState, filterByUltimoStato);

    const dialogCompletamento = ref(false);
    const dataCompletamento = ref(null);
    const codeCompletamento = ref("");
    const matriceSuggerita = ref(null);
    const ricercaMatriceInCorso = ref(false);
    const ricercaMatriceCompletata = ref(false);
    const salvataggioCompletamentoInCorso = ref(false);
    let ricercaMatriceTimer = null;
    let ultimaRicercaMatriceKey = "";
    const praticaInCompletamento = ref(null);
    const codeCompletamentoMask = computed(() => {
      const tipo = String(
        praticaInCompletamento.value?.tipo ||
        praticaInCompletamento.value?.tipoPratica ||
        ""
      ).toLowerCase();

      return tipo === "gas" ? "99999999999999" : "IT999E9999999*";
    });
    const isCodeCompletamentoValido = computed(() => {
      const code = String(codeCompletamento.value || "").trim().toUpperCase();
      const tipo = String(
        praticaInCompletamento.value?.tipo ||
        praticaInCompletamento.value?.tipoPratica ||
        ""
      ).toLowerCase();

      return tipo === "gas"
        ? /^\d{14}$/.test(code)
        : /^IT\d{3}E\d{7}[0-9A]$/.test(code);
    });
    const matriceRicercaMessage = computed(() => {
      if (!codeCompletamento.value) {
        return "Inserisci il Code per cercare un caricamento associabile.";
      }

      if (!isCodeCompletamentoValido.value) {
        return "Completa il Code per avviare la ricerca del caricamento.";
      }

      if (ricercaMatriceInCorso.value) {
        return "Ricerca caricamento in corso...";
      }

      if (matriceSuggerita.value) {
        return `Caricamento ${matriceSuggerita.value.matrice_id} trovato.`;
      }

      if (ricercaMatriceCompletata.value) {
        return "Nessun caricamento associabile trovato.";
      }

      return "Ricerca caricamento pronta.";
    });
    const isConfermaCompletamentoDisabled = computed(() => {
      return (
        !isCodeCompletamentoValido.value ||
        ricercaMatriceInCorso.value ||
        !dataCompletamento.value ||
        salvataggioCompletamentoInCorso.value
      );
    });

    const onAgentSelect = (event) => {
      console.log('onAgentSelect', event.value);
      nuovaPratica.value.agente = event.value;
    };

    const onCodeCompletamentoInput = () => {
      if (ricercaMatriceTimer) clearTimeout(ricercaMatriceTimer);

      const code = String(codeCompletamento.value || "").trim().toUpperCase();
      if (!code || !isCodeCompletamentoValido.value) {
        ricercaMatriceInCorso.value = false;
        ultimaRicercaMatriceKey = "";
        return;
      }

      const tipoRicerca = String(
        praticaInCompletamento.value?.tipo ||
        praticaInCompletamento.value?.tipoPratica ||
        ""
      );
      const ricercaKey = `${tipoRicerca.toLowerCase()}|${code}`;
      if (ultimaRicercaMatriceKey === ricercaKey && ricercaMatriceCompletata.value) {
        ricercaMatriceInCorso.value = false;
        return;
      }

      matriceSuggerita.value = null;
      ricercaMatriceCompletata.value = false;
      ricercaMatriceInCorso.value = true;
      ricercaMatriceTimer = setTimeout(async () => {
        try {
          ultimaRicercaMatriceKey = ricercaKey;
          const response = await service.cercaMatricePerCode({ code, tipo: tipoRicerca });
          matriceSuggerita.value = response?.gia_caricato ? null : response?.matrice || null;
        } catch (error) {
          console.error("Errore durante la ricerca della matrice:", error);
          matriceSuggerita.value = null;
        } finally {
          ricercaMatriceInCorso.value = false;
          ricercaMatriceCompletata.value = true;
        }
      }, 400);
    };

    watch(codeCompletamento, onCodeCompletamentoInput);

    const canChangePrivate = computed(() => {
      return user.value && allowedIdUser.includes(user.value.id);
    });

    const isPrivateAutomaticallyManaged = computed(() => {
      return service.getPrivateByNoteRule(
        selectedpratica.value?.selectedStato,
        selectedpratica.value?.nota
      ).isManaged;
    });

    watch(
      [
        () => selectedpratica.value?.selectedStato?.stato,
        () => selectedpratica.value?.nota,
      ],
      () => service.syncPrivateByNote(selectedpratica.value),
      { immediate: true }
    );

    const togglePrivate = async (data) => {
      if (!canChangePrivate.value) return;
      
      const newPrivateValue = data.is_private === 1 ? 0 : 1;
      
      try {
        await service.changePrivatePratica(data.id, newPrivateValue);
        data.is_private = newPrivateValue;
        toast.add({
          severity: 'success',
          summary: 'Successo',
          detail: 'Visibilità aggiornata con successo',
          life: 3000
        });
      } catch (error) {
        toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore durante l\'aggiornamento della visibilità',
          life: 3000
        });
      }
    };

    const dialogDelete = ref(false);
    const praticaToDelete = ref(null);

    const openDeleteDialog = (pratica) => {
      praticaToDelete.value = pratica;
      dialogDelete.value = true;
    };

    const confermaDelete = async () => {
      if (!praticaToDelete.value) return;

      try {
        loader.value = true;
        await service.deletePraticaFromId(
          'pratica_posa_contatore',
          praticaToDelete.value.id,
          'ModificaPosaContatore'
        );
        
        const index = ModificaPosaContatore.value.findIndex(p => p.id === praticaToDelete.value.id);
        if (index !== -1) {
          ModificaPosaContatore.value.splice(index, 1);
        }
        
        const filteredIndex = filteredModificaPosaContatore.value.findIndex(p => p.id === praticaToDelete.value.id);
        if (filteredIndex !== -1) {
          filteredModificaPosaContatore.value.splice(filteredIndex, 1);
        }

        dialogDelete.value = false;
        praticaToDelete.value = null;

        toast.add({
          severity: 'success',
          summary: 'Successo',
          detail: 'Pratica cancellata con successo',
          life: 3000
        });
      } catch (error) {
        const errorMessage = error.response?.data?.message || 'la pratica non può essere cancellata poichè è stata già lavorata.';
        toast.add({
          severity: 'error',
          summary: errorMessage.includes('non può essere cancellata') ? 'Attenzione' : 'Errore',
          detail: errorMessage,
          life: 3000
        });
      } finally {
        loader.value = false;
      }
    };

    const allCurrentPageSelected = computed(() => {
      return (
        filteredModificaPosaContatore.value.length > 0 &&
        selectedRows.value.length === filteredModificaPosaContatore.value.length
      );
    });

    return {
      loader,
      toast,
      get_id,
      ModificaPosaContatore,
      cod_pod,
      rappid,
      clientid,
      handleFileChange,
      chooseFile,
      selectedpratica,
      handleButtonClick3,
      handleButtonClick2,
      handleButtonClick,
      timelineData,
      sortedStates,
      startEditing,
      stopEditing,
      canEditCode,
      startCodeEditing,
      stopCodeEditing,
      dialoginfo,
      openInfoDialog,
      fetchCurrentStatus,
      filteredModificaPosaContatore,
      currentRecordIndex,
      changePraticaStatus,
      statiDisponibili,
      timelineKey,
      inviaNota,
      faseInvioStato,
      inviaStatoAnimato,
      statiSoloPreventivo,
      vedeSoloPreventivo,
      statiMassivi,
      impostaFilePreventivoFirmato,
      showFileUploadButton,
      uploadPreventiviPratiche,
      showSuccessAlert,
      showSuccessAlert2,
      dialogVisible,
      nuovaPratica,
      aggiungiPratica,
      aggiungiPraticaConferma,
      defaultDate,
      tensioneOptions,
      tipologiaContrattualeOptions,
      disalimentabileOptions,
      connessioneOptions,
      uddEditor,
      codicePraticaEditor,
      downloadPreventivoPratica,
      handleUploadPratiche,
      downloadAllegatoPratica,
      rimuoviFiltroStato,
      isActive,
      connessioneGasOptions,
      classeMisuratoreOptions,
      searchTerm,
      exportToExcel,
      selectedRows,
      massiveSelectedStatus,
      applyMassiveStatusChange,
      user,
      allowedIdUser,
      filterByPOD,
      filterByPDR,
      selectedState,
      filterByUltimoStato,
      activeFilter,
      setActiveFilter,
      types_stato_pratica,
      newStati,
      preventivoDialog,
      importoPreventivo,
      preventivoData,
      generaPreventivo,
      openPreventivo,
      preventivoEsistente,
      dialogCompletamento,
      dataCompletamento,
      codeCompletamento,
      codeCompletamentoMask,
      matriceRicercaMessage,
      matriceSuggerita,
      ricercaMatriceInCorso,
      ricercaMatriceCompletata,
      salvataggioCompletamentoInCorso,
      isConfermaCompletamentoDisabled,
      confermaCompletamento,
      tipologiaUsoOptions,
      filteredAgents,
      searchAgents,
      onAgentSelect,
      tableContainerRef,
      canChangePrivate,
      togglePrivate,
      dialogDelete,
      praticaToDelete,
      openDeleteDialog,
      confermaDelete,
      pagination,
      onPage,
      onSearch,
      allCurrentPageSelected,
      isPrivateAutomaticallyManaged
    };
  },
};
</script>

<style scoped>
.active-button {
  background-color: white !important;
  color: blue !important;
  border: 1px solid #0056b3;
}

#error-alert {
  display: none;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #ffcccc;
  padding: 10px 20px;
  border-radius: 5px;
  font-size: 16px;
  color: #ff0000;
  z-index: 1000;
}

.styled-button-Nota {
  background-color: #3498db;
  border: none;
  color: white;
  padding: 14px 24px;
  text-decoration: none;
  font-size: 13px;
  cursor: pointer;
  border-radius: 8px;
  margin-right: 10px;
  margin-bottom: 10px;
  align-self: stretch;
}

.styled-button-Nota:hover {
  background-color: #2980b9;
}

form {
  display: flex;
  flex-direction: column;
}

.form-container {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.button-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 10px;
}

.custom-file-upload {
  display: inline-block;
  padding: 12px 22px;
  font-size: 13px;
  cursor: pointer;
  background-color: #3498db;
  color: #fff;
  border-radius: 8px;
  border: none;
  transition: background-color 0.3s ease;
  margin-right: 10px;
  margin-bottom: 10px;
  text-align: center;
  width: 120px;
}

.custom-file-download {
  display: inline-block;
  padding: 14px 24px;
  font-size: 13px;
  cursor: pointer;
  background-color: #3498db;
  color: #fff;
  border-radius: 8px;
  border: none;
  transition: background-color 0.3s ease;
  margin-right: 10px;
  margin-bottom: 10px;
  text-align: center;
  width: 120px;
}

.custom-file-upload:hover {
  background-color: #2980b9;
}

input[type="file"] {
  display: none;
}

.custom-alert {
  background-color: #4caf50;
  color: white;
  padding: 15px;
  border-radius: 5px;
  position: fixed;
  z-index: 9999;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
  animation: fadeInOut 2s forwards;
}

@keyframes fadeInOut {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

.custom-alert:hover,
.custom-alert:focus {
  opacity: 1;
}

.custom-alert:hover,
.custom-alert:focus {
  animation: fadeOut 2s ease-in-out forwards;
}

.button-like:hover {
  text-decoration: none;
  color: navy;
}

.table-container {
  margin-top: 20px;
}

.pagination-summary {
  margin-top: 10px;
  font-size: 0.9rem;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

.pagination-summary__records {
  white-space: nowrap;
}

.popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  width: auto;
  max-width: 100%;
  max-height: 90vh;
  overflow: auto;
}

.popup-close {
  position: absolute;
  top: 3px;
  right: 5px;
  width: 20px;
  height: 20px;
  border: none;
  background: transparent;
  color: black;
  font-size: 18px;
  font-weight: bold;
  line-height: 1;
  cursor: pointer;
  outline: none;
}

.nota-container {
  display: flex;
  align-items: center;
}

.nota-container input {
  flex: 1;
  margin-right: 5px;
}

.popup-close:hover {
  color: darkgray;
}

.custom-dialog .dialog-content {
  display: flex;
  align-items: flex-start;
  gap: 24px;
}

.custom-dialog .timeline-container {
  flex: 0 0 280px;
  overflow: visible;
  margin: 0;
  padding: 4px 16px 4px 4px;
  border-right: 1px solid #e6ebf1;
}

.data-tables-container {
  flex: 1;
  overflow-x: auto;
}

.styled-button-Nota-Preventivo {
  background-color: #269a4d;
  border: none;
  color: white;
  padding: 12px 18px;
  text-decoration: none;
  font-size: 13px;
  cursor: pointer;
  border-radius: 8px;
  
}

.preventivo-esistente {
  background-color: #269a4d;
  padding: 15px;
  border-radius: 8px;
  margin-top: 10px;
  text-align: center;
  font-size: 16px;
}

.preventivo-esistente p {
  margin: 0;
  color: #f0f0f0;
}

.private-toggle {
  padding: 4px 12px;
  border-radius: 8px;
  transition: all 0.2s ease;
  display: inline-block;
}

.private-toggle:hover {
  background-color: #f0f0f0;
  transform: scale(1.05);
}

.private-si {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  font-weight: 600;
  box-shadow: 0 2px 4px rgba(40, 167, 69, 0.3);
}

.private-si:hover {
  background: linear-gradient(135deg, #218838 0%, #1ea085 100%);
  box-shadow: 0 3px 6px rgba(40, 167, 69, 0.4);
}

.cursor-pointer {
  cursor: pointer;
}

.completamento-saving-message {
  align-items: center;
  color: #175cd3;
  display: inline-flex;
  gap: .35rem;
  margin-top: .5rem;
}


.custom-dialog :deep(.p-dialog-content) {
  padding: 0.75rem 1rem;
}

.stato-pannello {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.stato-scheda {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  padding: 8px 12px;
  background: #f4f7fb;
  border: 1px solid #e3eaf2;
  border-radius: 8px;
}

.stato-scheda__voce {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.stato-scheda__voce span {
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.stato-scheda__voce strong {
  color: #0f172a;
  font-size: 14px;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.stato-blocco {
  padding: 10px 12px;
  border: 1px solid #e6ebf1;
  border-radius: 8px;
  background: #fff;
}

.stato-blocco h3 {
  margin: 0 0 8px;
  color: #0f3d6e;
  font-size: 14px;
}

.stato-campo {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 8px;
}

.stato-campo > span,
.stato-privato {
  color: #475569;
  font-size: 13px;
  font-weight: 600;
}

.stato-campo :deep(.p-dropdown) {
  width: 100%;
}

.stato-privato {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.stato-nota {
  width: 100%;
  min-height: 44px;
  height: 44px;
  resize: vertical;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 6px 10px;
  font: inherit;
  color: #0f172a;
  box-sizing: border-box;
}

.stato-modulo .styled-button-Nota {
  align-self: flex-start;
  margin: 0;
  min-width: 96px;
  padding: 8px 16px;
}

.stato-file {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.stato-file__riga {
  display: grid;
  grid-template-columns: 150px minmax(0, 1fr);
  align-items: center;
  gap: 8px;
  padding: 4px 0;
  border-bottom: 1px solid #eef2f6;
}

.stato-file__riga:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.stato-file__nome {
  color: #475569;
  font-size: 13px;
  font-weight: 600;
}

.stato-file .button-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0;
}

.stato-file .custom-file-upload,
.stato-file .custom-file-download {
  width: auto;
  min-width: 148px;
  min-height: 32px;
  margin: 0 8px 0 0;
  padding: 0 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-sizing: border-box;
}

.stato-importo .styled-button-Nota-Preventivo {
  padding: 8px 14px;
  margin: 0;
}

.stato-storico :deep(.p-datatable .p-datatable-thead > tr > th),
.stato-storico :deep(.p-datatable .p-datatable-tbody > tr > td) {
  padding: 0.35rem 0.6rem;
}

.stato-storico :deep(.p-paginator) {
  padding: 0.25rem 0 0;
}

.stato-importo .preventivo-esistente {
  margin-top: 0;
  padding: 8px 12px;
  font-size: 14px;
}

.stato-importo .preventivo-esistente p {
  margin: 0;
}

@media (max-width: 900px) {
  .custom-dialog.stato-dialog .dialog-content {
    flex-direction: column;
  }

  .custom-dialog.stato-dialog .timeline-container {
    flex: none;
    width: 100%;
    overflow: visible;
    border-right: none;
    border-bottom: 1px solid #e6ebf1;
  }

  .stato-scheda,
  .stato-file__riga {
    grid-template-columns: 1fr;
  }
}

.timeline-container :deep(.p-timeline-event-opposite) {
  display: none;
  flex: none;
  padding: 0;
}

.timeline-container :deep(.p-timeline-event-content) {
  padding: 0 0 12px 10px;
  line-height: 1.35;
}

.timeline-container :deep(.p-timeline-event-separator) {
  flex: none;
}

.stato-punto {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #cbd5e1;
  box-shadow: 0 0 0 3px #fff, 0 0 0 5px #cbd5e1;
}

.stato-punto--attivo {
  background: #2196f3;
  box-shadow: 0 0 0 3px #fff, 0 0 0 5px #2196f3;
}

.stato-passo__nome {
  display: block;
  margin-top: 1px;
  color: #475569;
  font-size: 14px;
}

.stato-passo__nome--attivo {
  color: #1565c0;
  font-weight: 700;
}


.styled-button-Nota--invio,
.styled-button-Nota--ok {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.styled-button-Nota:disabled {
  opacity: 1;
  cursor: default;
}

.styled-button-Nota--ok {
  background-color: #269a4d;
}

.invio-stato__spinner {
  width: 14px;
  height: 14px;
  margin-right: 8px;
  border: 2px solid rgba(255, 255, 255, 0.45);
  border-top-color: #fff;
  border-radius: 50%;
  animation: invio-stato-giro 0.7s linear infinite;
}

.invio-stato__check {
  display: inline-block;
  margin-right: 6px;
  font-weight: 700;
  animation: invio-stato-pop 0.35s ease;
}

@keyframes invio-stato-giro {
  to { transform: rotate(360deg); }
}

@keyframes invio-stato-pop {
  0% { transform: scale(0.4); opacity: 0; }
  70% { transform: scale(1.15); }
  100% { transform: scale(1); opacity: 1; }
}

</style>
